<template>

  <div class="bg-container">
    <div class="header header_b">
          <van-nav-bar :title="$t('q301')" class="header_b" style="background-color:#1f1c1f"> 
    <template #left>
            <img
              src="/img/newLogin/download.png"
              @click="back()"
              style="width: 20px; height: 15px"
            />
          </template>
    </van-nav-bar>
        </div>

    <div class="tu_list">
<section class="section section-relative " id="page-block-sfatg4kg7c" data-at="section">
      <div class="section-holder-border item-block item-absolute" data-at="section-border"></div>
      <div class="section-holder-overlay item-block item-absolute" data-at="section-overlay"></div>
      <div class="section-block">
        <div class="section-inner section-fit section-relative">
          <div class="widget item-absolute headline " id="element-734" data-at="headline">
            <div class="contents">
              <h1>
                <span class="x_fc9d998b x_5f0ed501"><span class="x_ebcb5a8d"><span class="x_9e1789bd">How does Amata Matchmaking
                       work?</span></span></span>
              </h1>
            </div>
          </div>
          <div class="widget item-absolute  " id="element-735">
            <div class="contents cropped item-block" data-at="image-cropp">
              <img class="item-content-box item-block image" data-at="image" alt="" src="//v.fastcdn.co/u/8f6a85c1/39215876-0-icon-48-px-circle-13.png" data-src="//v.fastcdn.co/u/8f6a85c1/39215876-0-icon-48-px-circle-13.png" data-retina-src="//v.fastcdn.co/u/8f6a85c1/39215876-0-icon-48-px-circle-13.png" data-retina-size-modificator=" 2x" srcset="//v.fastcdn.co/u/8f6a85c1/39215876-0-icon-48-px-circle-13.png 2x">
            </div>
          </div>
          <div class="widget item-absolute paragraph  " id="element-736" data-at="paragraph">
            <div class="contents">
              <p class="x_f72c77f2 x_9bc23194"><strong><span class="x_ebcb5a8d">Step 1</span></strong></p>
            </div>
          </div>
          <div class="widget item-absolute paragraph  " id="element-737" data-at="paragraph">
            <div class="contents">
              <p class="x_80f7663c x_390ad34e"><span class="x_ebcb5a8d"><span class="x_9e1789bd">Meet with our
                    experienced consultants for a friendly conversation
                    to learn more about you and your relationship goals.</span></span></p>
            </div>
          </div>
          <div class="widget item-absolute  " id="element-738">
            <div class="contents cropped item-block" data-at="image-cropp">
              <img class="item-content-box item-block image" data-at="image" alt="" src="//v.fastcdn.co/u/8f6a85c1/39215866-0-icon-48-px-circle-23.png" data-src="//v.fastcdn.co/u/8f6a85c1/39215866-0-icon-48-px-circle-23.png" data-retina-src="//v.fastcdn.co/u/8f6a85c1/39215866-0-icon-48-px-circle-23.png" data-retina-size-modificator=" 2x" srcset="//v.fastcdn.co/u/8f6a85c1/39215866-0-icon-48-px-circle-23.png 2x">
            </div>
          </div>
          <div class="widget item-absolute paragraph  " id="element-739" data-at="paragraph">
            <div class="contents">
              <p class="x_f72c77f2 x_9bc23194"><strong><span class="x_ebcb5a8d">Step 2</span></strong></p>
            </div>
          </div>
          <div class="widget item-absolute paragraph  " id="element-740" data-at="paragraph">
            <div class="contents">
              <p class="x_80f7663c x_390ad34e"><span class="x_ebcb5a8d"><span class="x_9e1789bd">After gathering some initial information, we will immediately begin searching for a partner who matches your preferences. Once the verification process is complete, I will promptly arrange your first meeting with the person you are interested in. While waiting for your match, you can consult with our professional relationship advisors.</span></span></p>
            </div>
          </div>
          <div class="widget item-absolute  " id="element-741">
            <div class="contents cropped item-block" data-at="image-cropp">
              <img class="item-content-box item-block image" data-at="image" alt="" src="//v.fastcdn.co/u/8f6a85c1/39215881-0-icon-48-px-circle-33.png" data-src="//v.fastcdn.co/u/8f6a85c1/39215881-0-icon-48-px-circle-33.png" data-retina-src="//v.fastcdn.co/u/8f6a85c1/39215881-0-icon-48-px-circle-33.png" data-retina-size-modificator=" 2x" srcset="//v.fastcdn.co/u/8f6a85c1/39215881-0-icon-48-px-circle-33.png 2x">
            </div>
          </div>
          <div class="widget item-absolute paragraph  " id="element-742" data-at="paragraph">
            <div class="contents">
              <p class="x_f72c77f2 x_9bc23194"><strong><span class="x_ebcb5a8d">Step 3</span></strong></p>
            </div>
          </div>
          <div class="widget item-absolute paragraph  " id="element-743" data-at="paragraph">
            <div class="contents">
              <p class="x_80f7663c x_390ad34e"><span class="x_ebcb5a8d"><span class="x_9e1789bd">Once we find a match
                    for you,
                    you simply go on a date.
                    And after the date, we will listen to your feedback to improve our service next time.</span></span>
              </p>
            </div>
          </div>
          <div class="widget item-absolute hidden-mobile" id="element-745">
            <div class="contents shape  line-horizontal line " data-at="shape"></div>
          </div>
          <div class="widget item-absolute hidden-mobile" id="element-746">
            <div class="contents shape  line-horizontal line " data-at="shape"></div>
          </div>
          <div class="widget item-absolute hidden-mobile" id="element-747">
            <div class="contents shape  line-horizontal line " data-at="shape"></div>
          </div>
          <div class="widget item-absolute hidden-mobile" id="element-744">
            <div class="contents shape  line-horizontal line " data-at="shape"></div>
          </div>
        </div>
      </div>
    </section>
<section class="section section-relative " id="page-block-7peatp556bf" data-at="section">
      <div class="section-holder-border item-block item-absolute" data-at="section-border"></div>
      <div class="section-holder-overlay item-block item-absolute" data-at="section-overlay"></div>
      <div class="section-block">
        <div class="section-inner section-fit section-relative">
          <div class="widget item-absolute headline " id="element-790" data-at="headline">
            <div class="contents">
              <h1>
                <span class="x_fc9d998b x_446dab97"><span class="x_ebcb5a8d"><span class="x_9e1789bd">Love Stories
                    </span></span></span>
              </h1>
            </div>
          </div>
          <div class="widget item-absolute paragraph  " id="element-791" data-at="paragraph">
            <div class="contents">
              <p class="x_7a88b5a4 x_8642b94b"><span class="x_ebcb5a8d"><span class="x_9e1789bd">Discover the inspiring
                    story of a couple who will motivate you to find true love. </span></span>
              </p>
            </div>
          </div>
          <div class="widget item-absolute " id="element-798">
            <div class="contents shape box figure" data-at="shape" data-src="/img/img1/03.png" style="background-repeat: no-repeat; background-position: center center; background-image: url(&quot;/img/img1/03.png&quot;);"></div>
          </div>
          <div class="widget item-absolute " id="element-792">
            <div class="contents shape box figure" data-at="shape" data-src="/img/img1/02.jpg" style="background-repeat: no-repeat; background-position: center center; background-image: url(&quot;/img/img1/02.jpg&quot;);"></div>
          </div>
          <div class="widget item-absolute " id="element-799">
            <div class="contents shape box figure" data-at="shape" data-src="/img/img1/03.jpg" style="background-repeat: no-repeat; background-position: center center; background-image: url(&quot;/img/img1/03.jpg&quot;);"></div>
          </div>
          <div class="widget item-absolute paragraph  " id="element-793" data-at="paragraph">
            <div class="contents">
              <p class="x_80f7663c x_390ad34e"><span class="x_f2074b6c"><span class="x_9e1789bd"><strong>-
                      Gavin and Mia Huang(married).</strong></span></span></p>
            </div>
          </div>
          <div class="widget item-absolute paragraph  " id="element-794" data-at="paragraph">
            <div class="contents">
              <p class="x_80f7663c x_390ad34e"><span class="x_f2074b6c"><span class="x_9e1789bd"><strong>-
                      Mr. Korn and Ms. Cheng (married).</strong></span></span></p>
            </div>
          </div>
          <div class="widget item-absolute paragraph  " id="element-800" data-at="paragraph">
            <div class="contents">
              <p class="x_80f7663c x_390ad34e"><span class="x_f2074b6c"><span class="x_9e1789bd"><strong>-
                      Ms. Ngim and Mr. Big (married).</strong></span></span></p>
            </div>
          </div>
          <div class="widget item-absolute " id="element-805">
            <div class="contents shape  line-horizontal line " data-at="shape"></div>
          </div>
          <div class="widget item-absolute " id="element-802">
            <div class="contents shape  line-horizontal line " data-at="shape"></div>
          </div>
          <div class="widget item-absolute " id="element-808">
            <div class="contents shape  line-horizontal line " data-at="shape"></div>
          </div>
          <div class="widget item-absolute paragraph  " id="element-795" data-at="paragraph">
            <div class="contents">
              <p class="x_1925a137 x_fc9d998b"><span class="x_ebcb5a8d"><span class="x_9e1789bd">"Finding someone who
                    matches your ideal type isn't difficult."</span></span></p>
            </div>
          </div>
          <div class="widget item-absolute paragraph  " id="element-804" data-at="paragraph">
            <div class="contents">
              <p class="x_1925a137 x_47b745f5"><span class="x_ebcb5a8d"><span class="x_9e1789bd">"I met the right person
                    and that's how I got married."</span></span></p>
            </div>
          </div>
          <div class="widget item-absolute paragraph  " id="element-807" data-at="paragraph">
            <div class="contents">
              <p class="x_b796efc8 x_5f0ed501"><span class="x_ebcb5a8d"><span class="x_9e1789bd">"I had someone to give
                    me advice until I had a successful date."</span></span></p>
            </div>
          </div>
          <div class="widget item-absolute " id="element-806">
            <div class="contents shape  line-horizontal line " data-at="shape"></div>
          </div>
          <div class="widget item-absolute " id="element-803">
            <div class="contents shape  line-horizontal line " data-at="shape"></div>
          </div>
          <div class="widget item-absolute " id="element-809">
            <div class="contents shape  line-horizontal line " data-at="shape"></div>
          </div>
          <div class="widget item-absolute paragraph  " id="element-801" data-at="paragraph">
            <div class="contents">
              <p class="x_7a88b5a4"><span class="x_ebcb5a8d"><span class="x_9e1789bd">Amata Matchmaking helps you find a date who perfectly matches your requirements in terms of personality, character, and appearance.</span></span></p>
            </div>
          </div>
          <div class="widget item-absolute paragraph  " id="element-796" data-at="paragraph">
            <div class="contents">
              <p class="x_7a88b5a4"><span class="x_ebcb5a8d"><span class="x_9e1789bd">If you are looking for someone Let Amata Matchmaking  help you. You won't have to waste time searching for the right person anymore. I'm very grateful to Amata Matchmaking for helping me meet Gr.&nbsp;&nbsp;</span></span></p>
            </div>
          </div>
          <div class="widget item-absolute paragraph  " id="element-797" data-at="paragraph">
            <div class="contents">
              <p class="x_7a88b5a4"><span class="x_ebcb5a8d"><span class="x_9e1789bd">Amata Matchmaking  taught me how to be a good date, and how to tell my date I'm interested. Ngim was my first date, and now we're married! Thank you so much, Amata Matchmaking !</span></span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
<section class="section section-relative " id="page-block-74qk0seeq8" data-at="section">
      <div class="section-holder-border item-block item-absolute" data-at="section-border"></div>
      <div class="section-holder-overlay item-block item-absolute" data-at="section-overlay"></div>
      <div class="section-block">
        <div class="section-inner section-fit section-relative">
          <div class="widget item-absolute " id="element-243">
            <div class="contents shape  box figure " data-at="shape"></div>
          </div>
          <div class="widget item-absolute  " id="element-236">
            <div class="contents item-block">
              <!-- <iframe class="item-block video iframe-lazy" type="text/html"
                data-src="https://www.youtube.com/embed/uJt2Ot_RQMM?showinfo&#x3D;0&amp;wmode&#x3D;transparent&amp;rel&#x3D;0&amp;autoplay&#x3D;0&amp;mute&#x3D;0&amp;controls&#x3D;1"
                allow="autoplay" allowfullscreen data-at="video-youtube"
                title="Amata Matchmaking Testimonial: Mr. Korn & Ms. Chen [Sub]" frameborder="0">
              </iframe> -->
              <video src="../../assets/1.mp4" controls="" style="width: 100%;aspect-ratio: 1;"></video>
            </div>
          </div>
          <div class="widget item-absolute  " id="element-237">
            <div class="contents item-block">
              <!-- <iframe class="item-block video iframe-lazy" type="text/html"
                data-src="https://www.youtube.com/embed/NbaExQ4orUA?showinfo&#x3D;0&amp;wmode&#x3D;transparent&amp;rel&#x3D;0&amp;autoplay&#x3D;0&amp;mute&#x3D;0&amp;controls&#x3D;1"
                allow="autoplay" allowfullscreen data-at="video-youtube"
                title="Amata Matchmaking - Testimonial: Nim & Pond [sub]" frameborder="0">
              </iframe> -->
              <video src="../../assets/2.mp4" controls="" style="width: 100%;aspect-ratio: 1;"></video>
            </div>
          </div>
        </div>
      </div>
    </section>
<section class="section section-relative " id="page_block_header" data-at="section">
      <div class="section-holder-border item-block item-absolute" data-at="section-border"></div>
      <div class="section-holder-overlay item-block item-absolute" data-at="section-overlay"></div>
      <div class="section-block">
        <div class="section-inner section-fit section-relative">
          <div class="widget item-absolute " id="element-385">
            <div class="contents shape box figure" data-at="shape" data-src="/img/img1/04.png" style="background-image: url(&quot;/img/img1/04.png&quot;);"></div>
          </div>
          <div class="widget item-absolute " id="element-386">
            <div class="contents shape box figure" data-at="shape" data-src="/img/img1/05.png" style="background-image: url(&quot;/img/img1/05.png&quot;);"></div>
          </div>
          <div class="widget item-absolute " id="element-387">
            <div class="contents shape box figure" data-at="shape" data-src="/img/img1/06.png" style="background-image: url(&quot;/img/img1/06.png&quot;);"></div>
          </div>
          <div class="widget item-absolute headline " id="element-471" data-at="headline">
            <div class="contents">
              <h1>
                <span class="x_519e17eb"><span class="x_ebcb5a8d">Amata Matchmaking is a consultant for the play The Cupids. 
                (Company of Love)</span></span>
              </h1>
            </div>
          </div>
          <div class="widget item-absolute headline " id="element-472" data-at="headline">
            <div class="contents">
              <h1>
                <span class="x_519e17eb"><span class="x_ebcb5a8d">Love knows no age; feelings matter. If the feeling is right, everything else is right.</span></span>
              </h1>
            </div>
          </div>

          <div class="widget item-absolute headline " id="element-473" data-at="headline">
            <div class="contents">
              <h1>
                <span class="x_519e17eb"><span class="x_ebcb5a8d">Distance has never been a factor affecting love, at least not in the face of true love.</span></span>
              </h1>
            </div>
          </div>

        </div>
      </div>
    </section>
	</div>
</div>
</template>

<script>
export default {
  data() {
    return {
      notice: this.$t("index.loading"),
      translateY: -18,
      containerHeight: 0,
      hasToken: false,
      basicData: [],
      datalist: [],
      groupedData: [],
      banners: [{}],
      bannerSwiperOption: {
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        speed: 800,
        autoplay: true,
        coverflowEffect: {
          rotate: 50,
          stretch: 10,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        },
      },
      tagTypes: ["primary", "success", "danger", "warning"],
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    getBasicConfig() {
      this.$http({
        method: "get",
        url: "sys_config",
      }).then((res) => {
        this.basicData = res.data;
        console.log(this.basicData, "309");
        this.getNotice(this.basicData); //获取公告
        this.getBanner(this.basicData); //获取banner
        // this.getGameItem();//获取首页游戏列表
        // this.getMovieList_0(this.basicData);//获取首页视频0
        // this.getMovieList_1(this.basicData);//获取首页视频1
      });
    },
    getHotLottery() {
      this.$http({
        method: "get",
        url: "lottery_hot",
      }).then((res) => {
        console.log(res, 11);
      });
    },
    getBanner(data) {
      this.banners = data.banners;
    },
    toLogin(str) {
      this.$router.push({ path: str });
    },
    getNotice(data) {
      this.notice = data.notice;
    },
    startAnimation() {
      const interval = setInterval(() => {
        this.translateY -= 18;

        if (this.translateY <= -this.containerHeight) {
          this.translateY = 0;
        }
      }, 1000);

      // 可选：在组件销毁时清除定时器
      this.$once("hook:beforeDestroy", () => {
        clearInterval(interval);
      });
    },
    toDetail(id) {
      this.$router.push({ path: "/detail", query: { id: id } });
    },
    checkToken() {
      const token = localStorage.getItem("token");
      console.log(token);
      this.hasToken = !!token; // 如果 token 存在，则 hasToken 为 true，否则为 false
      console.log(this.hasToken);
      this.$nextTick(() => {
        console.log("View updated:", this.hasToken);
      });
    },
    getxuanfeilist() {
      this.$http({
        method: "get",
        url: "xuanfeilist",
        data: { id: 1, page: 1 },
      }).then((res) => {
        const lanng = localStorage.getItem("lang");
        console.log(lanng);
        this.datalist = res.data;
        this.datalist.forEach((item) => {
          const parts = item.flag.split("|");
          lanng == "zh"
            ? (item.flag = parts[0])
            : lanng == "en"
            ? (item.flag = parts[1])
            : lanng == "ja"
            ? (item.flag = parts[2])
            : (item.flag = parts[3]);
          item.flagArray = item.flag.split("，");
        });
        const chunkSize = 2;
        this.groupedData = this.datalist.reduce((acc, item, index) => {
          if (index % chunkSize === 0) acc.push([]);
          acc[Math.floor(index / chunkSize)].push(item);
          return acc;
        }, []);
        console.log(this.groupedData);
        console.log(res.data);
      });
    },
  },

  mounted() {
    this.containerHeight = this.$refs.scrollContainer.clientHeight;
    this.startAnimation();
  },
  created() {
    this.checkToken();
    this.getBasicConfig();
    this.getxuanfeilist();
    this.getHotLottery();
  },
};
</script>

<style lang="less" scoped>
// @import "../../assets/css/index.css";


a:not(.btn):hover {
  text-decoration: underline;
}
input,
select,
textarea,
p,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  font-size: inherit;
  font-weight: inherit;
}

ol,
ul {
  padding-left: 2.5rem;
  margin: 0.625rem 0;
}
p {
  word-wrap: break-word;
}
h1 > span,
h2 > span,
h3 > span,
h4 > span,
h5 > span,
h6 > span {
  display: block;
  word-wrap: break-word;
}
iframe {
  border: 0;
}
* {
  box-sizing: border-box;
}
:root.js-text-scaling {
  --mobile-font-size: 4vw;
  --default-font-size: 16px;
}
.item-absolute {
  position: absolute;
}
.item-relative {
  position: relative;
}
.item-block {
  display: block;
  height: 100%;
  width: 100%;
}
.item-cover {
  z-index: var(--item-cover-z-index);
}
body#landing-page .iti--inline-dropdown .iti__dropdown-content,
body#landing-page .iti.iti--container.iti--fullscreen-popup {
  z-index: calc(var(--item-cover-z-index) + 1);
}
.item-breakword {
  word-wrap: break-word;
}
.item-content-box {
  box-sizing: content-box;
}
.hidden {
  display: none;
}
.hidden-step {
  visibility: hidden;
}
.clearfix {
  clear: both;
}
sup,
sub {
  margin-left: 0.1rem;
  line-height: 0;
}
body#landing-page .visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: none;
}
@keyframes slide-down {
  from {
    opacity: 0;
    transform: translateY(-50px);
  }
}
@keyframes fade-in {
  from {
    opacity: 0;
  }
}
@supports (-webkit-overflow-scrolling: touch) {
  @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
    .image[src$=".svg"] {
      width: calc(100% + 1px);
    }
  }
}
.show-for-sr {
  border: 0 !important;
  clip: rect(1px, 1px, 1px, 1px) !important;
  -webkit-clip-path: inset(50%) !important;
  clip-path: inset(50%) !important;
  height: 1px !important;
  margin: -1px !important;
  overflow: hidden !important;
  padding: 0 !important;
  position: absolute !important;
  width: 1px !important;
  white-space: nowrap !important;
}
.headline {
  font-family: Prompt;
  font-weight: 600;
}
.btn {
  line-height: 120%;
  text-align: center;
  font-family: Prompt;
  cursor: pointer;
  transition: border 0.5s;
  width: 100%;
  border: 0;
  white-space: normal;
  display: table-cell;
  vertical-align: middle;
  padding: 0;
}
.section-fit {
  max-width: 400px;
}
[class*="sticky-block-footer"] .section:last-child {
  bottom: 0;
  z-index: 1000015;
}
[class*="sticky-block-header"] .section:first-child {
  top: 0;
  z-index: 1000015;
}
.sticky-block-header .section:first-child,
.sticky-block-footer .section:last-child {
  position: sticky;
}
.section-relative {
  position: relative;
  /* margin: 0 auto; */
}
.js-text-scaling .section-relative {
  margin: var(--section-relative-margin);
}
.section-inner {
  height: 100%;
}
#page-block-gy1aig4hdp {
  height: 59.4375rem;
  max-width: 400px;
}
#page-block-gy1aig4hdp .section-holder-border {
  border: 0;
}
#page-block-gy1aig4hdp .section-block {
  background: repeat rgb(255, 255, 255) 50% 50% / cover;
  /* background-image: url("./main_bg.jpg"); */
  height: 59.4375rem;
}
#page-block-gy1aig4hdp .section-holder-overlay {
  display: none;
}
#element-552 {
  top: 0.5625rem;
  left: 5.1875rem;
  height: 4.5084rem;
  width: 4.5625rem;
  z-index: 75;
}
#element-817 {
  top: 5.375rem;
  left: 1.8125rem;
  height: 1.8125rem;
  width: 21.3125rem;
  z-index: 152;
  color: #fff;
  font-size: 1.1146rem;
  line-height: 1.8rem;
  text-align: center;
}
#element-817 .x_e79a2cef {
  text-align: center;
  line-height: 1.8125rem;
  font-size: 1.1146rem;
}
#element-817 .x_c3ede868 {
  color: #fff;
}
#element-541 {
  top: 7.6875rem;
  left: 2.875rem;
  height: 4.375rem;
  width: 19.5625rem;
  z-index: 29;
  color: #fff;
  font-size: 2.1672rem;
  line-height: 2.1875rem;
  text-align: center;
}
#element-541 .x_33228bbc {
  text-align: center;
  line-height: 2.1875rem;
  font-size: 2.1672rem;
}
#element-541 .x_c3ede868 {
  color: #fff;
}
#element-542 {
  top: 20.9375rem;
  left: 1.1875rem;
  height: 1.5625rem;
  width: 22.5rem;
  z-index: 31;
  color: #37465a;
  font-size: 1.1146rem;
  line-height: 1.575rem;
  text-align: center;
}
#element-542 .x_b8465762 {
  text-align: center;
  line-height: 1.5625rem;
  font-size: 1.1146rem;
}
#element-542 .x_c3ede868 {
  /* color: #32174d; */
  color: #fff;
}
#element-540 {
  top: 49.5rem;
  left: 6.25rem;
  height: 3.5rem;
  width: 12.25rem;
  z-index: 32;
}
.btn-shadow {
  box-shadow: 0 1px 3px rgba(1, 1, 1, 0.5);
}
#element-540 .btn.btn-effect3d:active {
  box-shadow: none;
}
#element-540 .btn:hover {
  background: #06d4a6;
  color: #ffffff;
}
#element-540 .btn {
  background: #0cdaac;
  color: #ffffff;
  font-size: 0.9907rem;
  font-family: Prompt;
  font-weight: 400;
  font-style: normal;
  height: 3.5rem;
  width: 12.25rem;
  border-radius: 3px;
}
#element-539 {
  top: 46.625rem;
  left: 0;
  height: 12.7836rem;
  width: 24.9375rem;
  z-index: 27;
}
#element-544 {
  top: 54.375rem;
  left: 11.0625rem;
  height: 2.6523rem;
  width: 2.5979rem;
  z-index: 35;
}
#page-block-aq16osz343o {
  height: 12.5rem;
  max-width: 100%;
}
#page-block-aq16osz343o .section-holder-border {
  border: 0;
}
#page-block-aq16osz343o .section-block {
  background: rgb(249, 249, 249);
  height: 12.5rem;
}
#page-block-aq16osz343o .section-holder-overlay {
  display: none;
}
#page-block-aq16osz343o .headline {
  font-family: Prompt;
  font-weight: 600;
}
#page-block-aq16osz343o .paragraph {
  font-family: Prompt;
  font-weight: 300;
}
#page-block-aq16osz343o .btn {
  font-family: Prompt;
}
#element-__gpage-block-aq16osz343o-822 {
  top: 2.625rem;
  left: 2.5625rem;
  height: 1.6875rem;
  width: 1.6875rem;
  z-index: 83;
}
.circle {
  border-radius: 50%;
}
.shape {
  height: inherit;
}
.line-horizontal {
  height: 0.625rem;
}
.line-vertical {
  height: 100%;
  margin-right: 0.625rem;
}
[class*="line-"] {
  box-sizing: content-box;
}
.item-relative .line-horizontal {
  height: 0;
  width: 100%;
}
.item-relative .line-vertical {
  height: 100%;
  width: 0;
}
.item-relative > .box,
.item-relative > .circle {
  width: 100%;
  height: 100%;
}
#element-__gpage-block-aq16osz343o-822 .shape {
  border: 0;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM89h8AApEBx2iaqpQAAAAASUVORK5CYII=)
    no-repeat 50% 50% / auto;
}
#element-__gpage-block-aq16osz343o-823 {
  top: 2.625rem;
  left: 5.1875rem;
  height: 1.75rem;
  width: 17.5rem;
  z-index: 84;
  color: #37465a;
  font-size: 1.2384rem;
  line-height: 1.75rem;
  text-align: left;
  font-weight: 700;
}
#element-__gpage-block-aq16osz343o-823 .x_b558b569 {
  text-align: left;
  line-height: 1.75rem;
  font-size: 1.2384rem;
}
#element-__gpage-block-aq16osz343o-823 strong {
  font-weight: 700;
}
#element-__gpage-block-aq16osz343o-823.headline {
  font-weight: 700;
}
#element-__gpage-block-aq16osz343o-824 {
  top: 5.75rem;
  left: 2.5625rem;
  height: 1.6875rem;
  width: 1.6875rem;
  z-index: 139;
}
#element-__gpage-block-aq16osz343o-824 .shape {
  border: 0;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM89h8AApEBx2iaqpQAAAAASUVORK5CYII=)
    no-repeat 50% 50% / auto;
}
#element-__gpage-block-aq16osz343o-825 {
  top: 5.75rem;
  left: 5.1875rem;
  height: 1.75rem;
  width: 17.5rem;
  z-index: 140;
  color: #37465a;
  font-size: 1.2384rem;
  line-height: 1.75rem;
  text-align: left;
  font-weight: 700;
}
#element-__gpage-block-aq16osz343o-825 .x_b558b569 {
  text-align: left;
  line-height: 1.75rem;
  font-size: 1.2384rem;
}
#element-__gpage-block-aq16osz343o-825 strong {
  font-weight: 700;
}
#element-__gpage-block-aq16osz343o-825.headline {
  font-weight: 700;
}
#element-__gpage-block-aq16osz343o-826 {
  top: 8.5625rem;
  left: 2.5625rem;
  height: 1.625rem;
  width: 1.625rem;
  z-index: 146;
}
#element-__gpage-block-aq16osz343o-826 .shape {
  border: 0;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM89h8AApEBx2iaqpQAAAAASUVORK5CYII=)
    no-repeat 50% 50% / auto;
}
#element-__gpage-block-aq16osz343o-827 {
  top: 8.5625rem;
  left: 5.1875rem;
  height: 1.75rem;
  width: 16.25rem;
  z-index: 149;
  color: #37465a;
  font-size: 1.2384rem;
  line-height: 1.75rem;
  text-align: left;
  font-weight: 700;
}
#element-__gpage-block-aq16osz343o-827 .x_b558b569 {
  text-align: left;
  line-height: 1.75rem;
  font-size: 1.2384rem;
}
#element-__gpage-block-aq16osz343o-827 strong {
  font-weight: 700;
}
#element-__gpage-block-aq16osz343o-827.headline {
  font-weight: 700;
}
#page-block-crp778w2dru {
  height: 57.75rem;
  max-width: 100%;
}
#page-block-crp778w2dru .section-holder-border {
  border: 0;
}
#page-block-crp778w2dru .section-block {
  background: url(//v.fastcdn.co/u/8f6a85c1/39260051-0-bg.png) repeat
    rgb(68, 43, 92) 50% 50% / auto;
  height: 57.75rem;
}
#page-block-crp778w2dru .section-holder-overlay {
  display: none;
}
#element-516 {
  top: 15.4375rem;
  left: 1.25rem;
  height: 27rem;
  width: 22.5rem;
  z-index: 145;
}
.form {
  font-size: 1.25rem;
}
fieldset {
  margin: 0;
  padding: 0;
  border: 0;
  min-width: 0;
}
.form-input {
  color: transparent;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 3px;
  font-family: inherit;
  width: 100%;
  height: 3.5rem;
  margin: var(--input-vertical-margin);
  padding: var(--input-padding);
}
.form-input::placeholder {
  opacity: 1;
  color: transparent;
}
.form-textarea {
  display: inline-block;
  vertical-align: top;
  resize: none;
}
.form-select {
  background: url("//v.fastcdn.co/a/img/builder2/select-arrow-drop-down.png")
    no-repeat right;
  -webkit-appearance: none;
  -moz-appearance: none;
  color: transparent;
}
.form-label {
  display: inline-block;
  color: transparent;
}
.form-label-title {
  display: block;
  line-height: 1.1;
  width: 100%;
  padding: 0.75rem 0 0.5625rem;
  margin: 0.5rem 0 0.125rem;
}
.form-multiple-label:empty {
  display: block;
  height: 0.8rem;
  margin-top: 0.375rem;
}
.form-label-outside {
  margin: 0.3125rem 0 0;
}
.form-multiple-input {
  position: absolute;
  opacity: 0;
}
.form-multiple-label {
  position: relative;
  padding-top: 0.75rem;
  line-height: 1.1;
  margin-left: 1.5625rem;
}
.form-multiple-label:before {
  content: "";
  display: inline-block;
  box-sizing: inherit;
  width: 1rem;
  height: 1rem;
  background-color: #fff;
  border-radius: 0.25rem;
  border: 1px solid #8195a8;
  margin-right: 0.5rem;
  vertical-align: -2px;
  position: absolute;
  left: -1.5625rem;
  top: 0.85rem;
}
.form-checkbox-label:after {
  content: "";
  width: 0.25rem;
  height: 0.5rem;
  position: absolute;
  top: 0.8rem;
  left: -1.25rem;
  transform: rotate(45deg);
  border-right: 0.1875rem solid;
  border-bottom: 0.1875rem solid;
  color: #fff;
}
.form-checkbox-label a {
  color: #243dae;
}
.form-radio-label:before {
  border-radius: 50%;
}
.form-multiple-input:focus + .form-multiple-label:before {
  border: 2px solid #308dfc;
}
.form-multiple-input:checked + .form-radio-label:before {
  border: 0.3125rem solid #308dfc;
}
.form-multiple-input:checked + .form-checkbox-label:before {
  background-color: #308dfc;
  border: 0;
}
.form-btn {
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: transparent;
  border: 0;
  cursor: pointer;
  min-height: 100%;
}
.form-input-inner-shadow {
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.28);
}
body#landing-page .user-invalid-label {
  color: #e85f54;
}
body#landing-page .user-invalid {
  border-color: #e85f54;
}
.form-messagebox {
  transform: translate(0.4375rem, -0.4375rem);
}
.form-messagebox:before {
  content: "";
  position: absolute;
  display: block;
  width: 0.375rem;
  height: 0.375rem;
  transform: rotate(45deg);
  background-color: #e85f54;
  top: -0.1875rem;
  left: 25%;
}
.form-messagebox-contents {
  font-size: 0.875rem;
  font-weight: 500;
  color: #fff;
  background-color: #e85f54;
  padding: 0.4375rem 0.9375rem;
  max-width: 250px;
  word-wrap: break-word;
  margin: auto;
}
.form-messagebox-top {
  transform: translate(0, -1rem);
}
.form-messagebox-top:before {
  bottom: -0.1875rem;
  top: auto;
}
.form .phone-input-container {
  width: 100%;
  margin: var(--input-vertical-margin);
}
.form .phone-input-container .iti__selected-country-primary {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 64px;
  gap: 4px;
  border-right: 1px solid transparent;
}
.form .phone-input-container .iti__selected-country-primary .iti__arrow {
  border: solid #5d5d5d;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(45deg);
  margin-bottom: 3px;
}
.form
  .phone-input-container
  .iti__selected-country-primary
  .iti__arrow.iti__arrow--up {
  transform: rotate(225deg);
  margin-bottom: 0;
}
.form .phone-input-container .iti__selected-dial-code {
  color: #000000;
  font-weight: 400;
  margin-left: 6px;
  margin-bottom: 1px;
}
.form .phone-input-container .iti__search-input {
  padding: var(--input-padding);
}
body#landing-page
  .form
  .phone-input-container
  [id^="phone-input-field-"]::placeholder,
body#landing-page .form .phone-input-container .iti__search-input::placeholder {
  color: #5d5d5d;
}
body#landing-page
  .form
  .phone-input-container:has(input.user-invalid)
  .iti__selected-country-primary {
  border-color: #e85f54;
}
.form
  .phone-input-container
  .iti__selected-country-primary
  .iti__flag:not(.iti__globe) {
  transform: scale(1.2);
  box-shadow: none;
  border-radius: 0;
  background-image: var(--iti-path-flags-2x);
}
.lightbox {
  display: none;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
}
.lightbox--no-animation .lightbox-dim {
  animation: none;
}
.lightbox--no-animation .lightbox-content {
  animation: none;
}
.lightbox-dim {
  background: rgba(0, 0, 0, 0.85);
  height: 100%;
  animation: fade-in 0.5s ease-in-out;
  overflow-x: hidden;
  display: flex;
  align-items: center;
  padding: 30px 0;
}
.lightbox-content {
  background-color: #fefefe;
  border-radius: 3px;
  position: relative;
  margin: auto;
  animation: slide-down 0.5s ease-in-out;
}
.lightbox-opened {
  display: block;
}
.lightbox-close {
  width: 26px;
  right: 0;
  top: -10px;
  cursor: pointer;
}
.lightbox-close-btn {
  padding: 0;
  border: none;
  background: none;
}
.lightbox-btn-svg {
  display: block;
}
.lightbox-close-icon {
  fill: #fff;
}
.notification-text {
  font-size: 1.5rem;
  color: #fff;
  text-align: center;
  width: 100%;
}
.modal-on {
  overflow: hidden;
}
.popup-link {
  cursor: pointer;
}
#element-28 {
  top: 0;
  left: 0;
  height: 27rem;
  width: 22.5rem;
  z-index: 19;
}
#element-28 .btn.btn-effect3d:active {
  box-shadow: none;
}
#element-28 .btn:hover {
  background: #16cea5;
  color: #ffffff;
}
#element-28 .btn {
  background: #0cdaac;
  color: #ffffff;
  font-size: 1.0526rem;
  font-family: Prompt;
  font-weight: 400;
  font-style: normal;
  height: 3.25rem;
  width: 22.5rem;
  border-radius: 3px;
}
#element-28 .form-label {
  color: #cfc0db;
}
#element-28 ::placeholder {
  color: #cfc0db;
}
#element-28 .form-input {
  color: #ffffff;
  background-color: #8761a4;
  border-color: #8761a4;
}
#element-28 .iti__country-container .iti__selected-country-primary {
  border-color: #8761a4;
}
#element-28 .form-select[aria-invalid="false"] {
  color: #ffffff;
}
#element-28 .user-invalid {
  border-color: #e12627;
}
#element-28 input::placeholder,
#element-28 .form-label-inside {
  color: #cfc0db;
}
#element-28 select.valid {
  color: #ffffff;
}
#element-28 .form-btn-geometry {
  top: 28.5rem;
  left: 0;
  height: 3.25rem;
  width: 22.5rem;
  z-index: 145;
}
#element-32 {
  top: 18.6875rem;
  left: 1.25rem;
  height: 1.3125rem;
  width: 22.5rem;
  z-index: 146;
}
#element-32 .shape {
  border-bottom: 1px solid #cfc0db;
}
#element-33 {
  top: 23.3125rem;
  left: 1.25rem;
  height: 1.3125rem;
  width: 22.5rem;
  z-index: 147;
}
#element-33 .shape {
  border-bottom: 1px solid #cfc0db;
}
#element-30 {
  top: 4.5625rem;
  left: 1.5rem;
  height: 5rem;
  width: 22rem;
  z-index: 14;
  color: #98a0a6;
  font-size: 2.0433rem;
  line-height: 2.475rem;
  text-align: center;
}
#element-30 .x_993ff5e9 {
  text-align: center;
  line-height: 2.5rem;
  font-size: 2.0433rem;
}
#element-30 .x_f2074b6c {
  color: #ffffff;
}
#element-30 .x_41ae8345 {
  text-align: left;
  caret-color: rgb(255, 255, 255);
}
#element-31 {
  top: 10.5625rem;
  left: 1.5rem;
  height: 3rem;
  width: 22rem;
  z-index: 15;
  color: #98a0a6;
  font-size: 1.2384rem;
  line-height: 1.5rem;
  text-align: center;
}
#element-31 .x_4fa66b73 {
  text-align: center;
  line-height: 1.5rem;
  font-size: 1.2384rem;
}
#element-31 .x_f2074b6c {
  color: #ffffff;
}
#element-34 {
  top: 27.9375rem;
  left: 1.25rem;
  height: 1.3125rem;
  width: 22.5rem;
  z-index: 148;
}
#element-34 .shape {
  border-bottom: 1px solid #cfc0db;
}
#element-35 {
  top: 37.1875rem;
  left: 1.25rem;
  height: 1.3125rem;
  width: 22.5rem;
  z-index: 149;
}
#element-35 .shape {
  border-bottom: 1px solid #cfc0db;
}
#element-36 {
  top: 32.5625rem;
  left: 1.25rem;
  height: 1.3125rem;
  width: 22.5rem;
  z-index: 150;
}
#element-36 .shape {
  border-bottom: 1px solid #cfc0db;
}
#element-815 {
  top: 41.75rem;
  left: 1.25rem;
  height: 1.3125rem;
  width: 22.5rem;
  z-index: 151;
}
#element-815 .shape {
  border-bottom: 1px solid #cfc0db;
}
#element-523 {
  top: 48.375rem;
  left: 3.5rem;
  height: 2.5rem;
  width: 18rem;
  z-index: 76;
  color: #37465a;
  font-size: 0.8669rem;
  line-height: 1.225rem;
  text-align: center;
}
#element-523 .x_c5f0bf77 {
  text-align: center;
  line-height: 1.25rem;
  font-size: 0.8669rem;
}
#element-523 .x_3f8b9c9e {
  color: #cfc0db;
}
#element-813 {
  top: 52.1875rem;
  left: 12.3125rem;
  height: 2.4798rem;
  width: 7.5rem;
  z-index: 143;
}
#element-813 .cropped {
  background: url(//v.fastcdn.co/u/8f6a85c1/58811452-0-Privacy-Policy.png) 0 0 /
    7.6875rem 2.4375rem;
}
#element-814 {
  top: 52.1875rem;
  left: 5.125rem;
  height: 2.5rem;
  width: 6.75rem;
  z-index: 144;
}
#page-block-7kbrls2f8wa {
  height: 10.75rem;
  max-width: 100%;
}
#page-block-7kbrls2f8wa .section-holder-border {
  border: 0;
}
#page-block-7kbrls2f8wa .section-block {
  background: none;
  height: 10.75rem;
}
#page-block-7kbrls2f8wa .section-holder-overlay {
  display: none;
}
#element-762 {
  top: 1.5625rem;
  left: 1.25rem;
  height: 3.9035rem;
  width: 5.1875rem;
  z-index: 115;
}
#element-763 {
  top: 1.5625rem;
  left: 7.0625rem;
  height: 3.9505rem;
  width: 5.25rem;
  z-index: 117;
}
#element-764 {
  top: 1.5rem;
  left: 12.8125rem;
  height: 3.9035rem;
  width: 5.1875rem;
  z-index: 118;
}
#element-765 {
  top: 1.5625rem;
  left: 18.5rem;
  height: 3.9505rem;
  width: 5.25rem;
  z-index: 119;
}
#element-766 {
  top: 5.375rem;
  left: 1.25rem;
  height: 3.9035rem;
  width: 5.1875rem;
  z-index: 120;
}
#element-767 {
  top: 5.4375rem;
  left: 7.125rem;
  height: 3.7624rem;
  width: 5rem;
  z-index: 121;
}
#element-768 {
  top: 5.4375rem;
  left: 12.8125rem;
  height: 3.8094rem;
  width: 5.0625rem;
  z-index: 141;
}
#element-769 {
  top: 5.375rem;
  left: 18.5rem;
  height: 3.9505rem;
  width: 5.25rem;
  z-index: 142;
}
#page-block-6y050oio77h {
  height: 53.5rem;
  max-width: 100%;
}
#page-block-6y050oio77h .section-holder-border {
  border: 0;
}
#page-block-6y050oio77h .section-block {
  background: rgb(249, 249, 249);
  height: 53.5rem;
}
#page-block-6y050oio77h .section-holder-overlay {
  display: none;
}
#element-41 {
  top: 4.5rem;
  left: 0.625rem;
  height: 10.75rem;
  width: 7.75rem;
  z-index: 37;
}
#element-41 .shape {
  border: 0;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM89h8AApEBx2iaqpQAAAAASUVORK5CYII=)
    repeat rgb(240, 243, 245) 67% 47% / cover;
}
#element-42 {
  top: 4.5rem;
  left: 8.625rem;
  height: 10.75rem;
  width: 7.75rem;
  z-index: 38;
}
#element-42 .shape {
  border: 0;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM89h8AApEBx2iaqpQAAAAASUVORK5CYII=)
    repeat rgb(240, 243, 245) 50% 50% / cover;
}
#element-44 {
  top: 4.5rem;
  left: 16.625rem;
  height: 10.75rem;
  width: 7.75rem;
  z-index: 39;
}
#element-44 .shape {
  border: 0;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM89h8AApEBx2iaqpQAAAAASUVORK5CYII=)
    repeat rgb(240, 243, 245) 50% 50% / cover;
}
#element-43 {
  top: 15.5rem;
  left: 0.625rem;
  height: 10.75rem;
  width: 7.75rem;
  z-index: 40;
}
#element-43 .shape {
  border: 0;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM89h8AApEBx2iaqpQAAAAASUVORK5CYII=)
    repeat rgb(240, 243, 245) 60% 53% / cover;
}
#element-45 {
  top: 15.5rem;
  left: 8.625rem;
  height: 10.75rem;
  width: 7.75rem;
  z-index: 41;
}
#element-45 .shape {
  border: 0;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM89h8AApEBx2iaqpQAAAAASUVORK5CYII=)
    repeat rgb(240, 243, 245) 59% 54% / cover;
}
#element-526 {
  top: 15.5rem;
  left: 16.625rem;
  height: 10.75rem;
  width: 7.75rem;
  z-index: 42;
}
#element-526 .shape {
  border: 0;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM89h8AApEBx2iaqpQAAAAASUVORK5CYII=)
    repeat rgb(240, 243, 245) 98% 58% / cover;
}
#element-39 {
  top: 29.3125rem;
  left: 1.5rem;
  height: 2.125rem;
  width: 22rem;
  z-index: 36;
  color: #98a0a6;
  font-size: 1.7337rem;
  line-height: 2.1rem;
  text-align: center;
}
#element-39 .x_446dab97 {
  text-align: center;
  line-height: 2.125rem;
  font-size: 1.7337rem;
}
#element-39 .x_ebcb5a8d {
  color: #484848;
}
#element-40 {
  top: 32.4375rem;
  left: 1.5rem;
  height: 16.5rem;
  width: 22rem;
  z-index: 34;
  color: #98a0a6;
  font-size: 1.0526rem;
  line-height: 1.4875rem;
  text-align: center;
}
#element-40 .x_8642b94b {
  text-align: center;
  line-height: 1.5rem;
  font-size: 1.0526rem;
}
#element-40 .x_ebcb5a8d {
  color: #484848;
}
#element-40 .x_9e1789bd {
  text-align: left;
  caret-color: rgb(72, 72, 72);
}
#page-block-5yybmqvsesc {
  height: 53.5rem;
  max-width: 100%;
}
#page-block-5yybmqvsesc .section-holder-border {
  border: 0;
}
#page-block-5yybmqvsesc .section-block {
  background: none;
  height: 53.5rem;
}
#page-block-5yybmqvsesc .section-holder-overlay {
  display: none;
}
#element-567 {
  top: 4.5rem;
  left: 1.25rem;
  height: 1.5rem;
  width: 22.5rem;
  z-index: 77;
  color: #98a0a6;
  font-size: 1.2384rem;
  line-height: 1.5rem;
  text-align: center;
}
#element-567 .x_bdb4a4e4 {
  text-align: center;
  line-height: 1.5rem;
  font-size: 1.2384rem;
}
#element-567 .x_ebcb5a8d {
  color: #484848;
}
#element-569 {
  top: 8.4375rem;
  left: 3rem;
  height: 14.5625rem;
  width: 18.625rem;
  z-index: 104;
}
#element-569 .shape {
  border: 0;
  background: none;
}
#element-568 {
  top: 8.4375rem;
  left: 10.4375rem;
  height: 4rem;
  width: 4rem;
  z-index: 103;
}
#element-577 {
  top: 13.375rem;
  left: 3.0625rem;
  height: 1.875rem;
  width: 18.75rem;
  z-index: 105;
  color: #98a0a6;
  font-size: 1.1765rem;
  line-height: 1.9rem;
  text-align: center;
}
#element-577 .x_4b32d65e {
  text-align: center;
  line-height: 1.875rem;
  font-size: 1.1765rem;
}
#element-577 .x_c3ede868 {
  color: #32174d;
}
#element-582 {
  top: 16.75rem;
  left: 3.9375rem;
  height: 2.375rem;
  width: 7.6875rem;
  z-index: 108;
}
#element-582 .shape {
  border: 0;
  border-radius: 6.25rem 6.25rem 6.25rem 6.25rem;
  background: rgb(228, 248, 245);
}
#element-583 {
  top: 17.4375rem;
  left: 4.1875rem;
  height: 1.375rem;
  width: 7.25rem;
  z-index: 109;
  color: #37465a;
  font-size: 0.8669rem;
  line-height: 1.4rem;
  text-align: center;
}
#element-583 .x_938e8cfc {
  text-align: center;
  line-height: 1.375rem;
  font-size: 0.8669rem;
}
#element-583 .x_b9f91c43 {
  color: #4ac5b6;
}
#element-584 {
  top: 16.75rem;
  left: 13rem;
  height: 2.375rem;
  width: 7.6875rem;
  z-index: 111;
}
#element-584 .shape {
  border: 0;
  border-radius: 6.25rem 6.25rem 6.25rem 6.25rem;
  background: rgb(255, 223, 221);
}
#element-585 {
  top: 17.4375rem;
  left: 13.25rem;
  height: 1.375rem;
  width: 7.25rem;
  z-index: 112;
  color: #37465a;
  font-size: 0.8669rem;
  line-height: 1.4rem;
  text-align: center;
}
#element-585 .x_938e8cfc {
  text-align: center;
  line-height: 1.375rem;
  font-size: 0.8669rem;
}
#element-585 .x_249cd66c {
  color: #de6661;
}
#element-580 {
  top: 20.0625rem;
  left: 4.125rem;
  height: 2.125rem;
  width: 7.25rem;
  z-index: 106;
  color: #37465a;
  font-size: 1.7337rem;
  line-height: 2.1rem;
  text-align: center;
}
#element-580 .x_446dab97 {
  text-align: center;
  line-height: 2.125rem;
  font-size: 1.7337rem;
}
#element-580 .x_ebcb5a8d {
  color: #484848;
}
#element-581 {
  top: 20.0625rem;
  left: 13.1875rem;
  height: 2.125rem;
  width: 7.25rem;
  z-index: 107;
  color: #37465a;
  font-size: 1.7337rem;
  line-height: 2.1rem;
  text-align: center;
}
#element-581 .x_446dab97 {
  text-align: center;
  line-height: 2.125rem;
  font-size: 1.7337rem;
}
#element-581 .x_ebcb5a8d {
  color: #484848;
}
#element-570 {
  top: 25.125rem;
  left: 2.125rem;
  height: 13.625rem;
  width: 20.5rem;
  z-index: 90;
}
#element-570 .shape {
  border: 0;
  background: none;
}
#element-572 {
  top: 25.125rem;
  left: 10.5rem;
  height: 4rem;
  width: 4rem;
  z-index: 91;
}
#element-576 {
  top: 30.1875rem;
  left: 2.8125rem;
  height: 1.875rem;
  width: 19.4375rem;
  z-index: 92;
  color: #98a0a6;
  font-size: 1.1765rem;
  line-height: 1.9rem;
  text-align: center;
}
#element-576 .x_4b32d65e {
  text-align: center;
  line-height: 1.875rem;
  font-size: 1.1765rem;
}
#element-576 .x_c3ede868 {
  color: #32174d;
}
#element-578 {
  top: 33rem;
  left: 9.5rem;
  height: 2.125rem;
  width: 6rem;
  z-index: 93;
  color: #37465a;
  font-size: 1.7337rem;
  line-height: 2.1rem;
  text-align: center;
}
#element-578 .x_446dab97 {
  text-align: center;
  line-height: 2.125rem;
  font-size: 1.7337rem;
}
#element-579 {
  top: 35.25rem;
  left: 3rem;
  height: 1.375rem;
  width: 19rem;
  z-index: 94;
  color: #37465a;
  font-size: 0.9907rem;
  line-height: 1.4rem;
  text-align: center;
}
#element-579 .x_2c80ab57 {
  text-align: center;
  line-height: 1.375rem;
  font-size: 0.9907rem;
}
#element-579 .x_ebcb5a8d {
  color: #484848;
}
#element-571 {
  top: 38.1875rem;
  left: 3.125rem;
  height: 13.9375rem;
  width: 18.625rem;
  z-index: 85;
}
#element-571 .shape {
  border: 0;
  background: none;
}
#element-573 {
  top: 38.1875rem;
  left: 10.125rem;
  height: 4rem;
  width: 4rem;
  z-index: 86;
}
#element-575 {
  top: 43.1875rem;
  left: 3.1875rem;
  height: 1.875rem;
  width: 18.75rem;
  z-index: 88;
  color: #98a0a6;
  font-size: 1.1765rem;
  line-height: 1.9rem;
  text-align: center;
}
#element-575 .x_4b32d65e {
  text-align: center;
  line-height: 1.875rem;
  font-size: 1.1765rem;
}
#element-575 .x_c3ede868 {
  color: #32174d;
}
#element-574 {
  top: 46rem;
  left: 3rem;
  height: 5.0625rem;
  width: 18.75rem;
  z-index: 87;
  color: #98a0a6;
  font-size: 1.0526rem;
  line-height: 1.7rem;
  text-align: center;
}
#element-574 .x_7a88b5a4 {
  text-align: center;
  line-height: 1.6875rem;
  font-size: 1.0526rem;
}
#element-574 .x_ebcb5a8d {
  color: #484848;
}
#element-574 .x_9e1789bd {
  text-align: left;
  caret-color: rgb(72, 72, 72);
}
#element-586 {
  top: 52.1875rem;
  left: 1.5rem;
  height: 1.3125rem;
  width: 22.5rem;
  z-index: 114;
}
#element-586 .shape {
  border-bottom: 1px solid #f0f0f0;
}
#page-block-cwbu8jp41s {
  height: 65.0625rem;
  max-width: 100%;
}
#page-block-cwbu8jp41s .section-holder-border {
  border: 0;
}
#page-block-cwbu8jp41s .section-block {
  background: rgb(255, 255, 255);
  height: 45.0625rem;
}
#page-block-cwbu8jp41s .section-holder-overlay {
  display: none;
}
#element-707 {
  top: 2rem;
  left: 0;
  height: 4.25rem;
  width: 25rem;
  z-index: 16;
  color: #98a0a6;
  font-size: 1.7337rem;
  line-height: 2.1rem;
  text-align: center;
}
#element-707 .x_446dab97 {
  text-align: center;
  line-height: 2.125rem;
  font-size: 1.7337rem;
}
#element-707 .x_ebcb5a8d {
  color: #484848;
}
#element-707 .x_9e1789bd {
  text-align: left;
  caret-color: rgb(72, 72, 72);
}
#element-708 {
  top: 8.25rem;
  left: 4.0625rem;
  height: auto;
  width: 16.8125rem;
  z-index: 17;
  color: #98a0a6;
  font-size: 1.0526rem;
  line-height: 1.4875rem;
  text-align: center;
}
#element-708 .x_8642b94b {
  text-align: center;
  line-height: 1.5rem;
  font-size: 1.0526rem;
}
#element-708 .x_ebcb5a8d {
  color: #484848;
}
#element-708 .x_9e1789bd {
  text-align: left;
  caret-color: rgb(72, 72, 72);
}
#element-710 {
  top: 25.3125rem;
  left: 1.4375rem;
  height: 2.9605rem;
  width: 2.8125rem;
  z-index: 19;
}
#element-710 .cropped {
  background: url(//v.fastcdn.co/u/8f6a85c1/49951090-0-1B.svg) -0.0625rem 0 /
    2.875rem 3rem;
}
#element-712 {
  top: 38.9375rem;
  left: 1.4375rem;
  height: 3.0625rem;
  width: 3.0625rem;
  z-index: 22;
}
#element-712 .cropped {
  background: url(//v.fastcdn.co/u/8f6a85c1/49951100-0-2B.svg) 0 -0.0625rem /
    3.0625rem 3.1875rem;
}
#element-714 {
  top: 45rem;
  left: 1.4375rem;
  height: 3.0625rem;
  width: 3.0625rem;
  z-index: 26;
}
#element-714 .cropped {
  background: url(//v.fastcdn.co/u/8f6a85c1/49951110-0-3B.svg) 0 -0.0625rem /
    3.0625rem 3.1875rem;
}
#element-716 {
  top: 52.375rem;
  left: 1.4375rem;
  height: 3.25rem;
  width: 3.25rem;
  z-index: 30;
}
#element-716 .cropped {
  background: url(//v.fastcdn.co/u/8f6a85c1/49951115-0-4B.svg) 0 -0.0625rem /
    3.25rem 3.375rem;
}
#element-709 {
  top: 25.3125rem;
  left: 6.125rem;
  height: auto;
  width: 17.3125rem;
  z-index: 18;
  color: #98a0a6;
  font-size: 1.0526rem;
  line-height: 1.7rem;
  text-align: left;
}
#element-709 .x_db4a4d62 {
  text-align: left;
  line-height: 1.6875rem;
  font-size: 1.0526rem;
}
#element-709 .x_ebcb5a8d {
  color: #484848;
}
#element-709 .x_9e1789bd {
  text-align: left;
  caret-color: rgb(72, 72, 72);
}
#element-711 {
  top: 38.9375rem;
  left: 6.4375rem;
  height: auto;
  width: 17.25rem;
  z-index: 20;
  color: #98a0a6;
  font-size: 1.0526rem;
  line-height: 1.7rem;
  text-align: left;
}
#element-711 .x_db4a4d62 {
  text-align: left;
  line-height: 1.6875rem;
  font-size: 1.0526rem;
}
#element-711 .x_ebcb5a8d {
  color: #484848;
}
#element-711 .x_9e1789bd {
  text-align: left;
  caret-color: rgb(72, 72, 72);
}
#element-713 {
  top: 45rem;
  left: 6.75rem;
  height: auto;
  width: 17.3125rem;
  z-index: 24;
  color: #98a0a6;
  font-size: 1.0526rem;
  line-height: 1.7rem;
  text-align: left;
}
#element-713 .x_db4a4d62 {
  text-align: left;
  line-height: 1.6875rem;
  font-size: 1.0526rem;
}
#element-713 .x_ebcb5a8d {
  color: #484848;
}
#element-713 .x_9e1789bd {
  text-align: left;
  caret-color: rgb(72, 72, 72);
}
#element-715 {
  top: 52.3125rem;
  left: 6.1875rem;
  height: auto;
  width: 16.75rem;
  z-index: 28;
  color: #98a0a6;
  font-size: 1.0526rem;
  line-height: 1.7rem;
  text-align: left;
}
#element-715 .x_db4a4d62 {
  text-align: left;
  line-height: 1.6875rem;
  font-size: 1.0526rem;
}
#element-715 .x_ebcb5a8d {
  color: #484848;
}
#element-715 .x_9e1789bd {
  text-align: left;
  caret-color: rgb(72, 72, 72);
}
#page-block-u6qrj13o0v {
  height: 76.25rem;
  max-width: 100%;
}
#page-block-u6qrj13o0v .section-holder-border {
  border: 0;
}
#page-block-u6qrj13o0v .section-block {
  background: none;
  height: 76.25rem;
}
#page-block-u6qrj13o0v .section-holder-overlay {
  display: none;
}
#element-730 {
  top: 2.5rem;
  left: 1.25rem;
  height: 9.375rem;
  width: 22.5rem;
  z-index: 123;
}
#element-729 {
  top: 13.625rem;
  left: 3.4375rem;
  height: 3rem;
  width: 18.125rem;
  z-index: 124;
  color: #98a0a6;
  font-size: 1.2384rem;
  line-height: 1.5rem;
  text-align: center;
}
#element-729 .x_bdb4a4e4 {
  text-align: center;
  line-height: 1.5rem;
  font-size: 1.2384rem;
}
#element-729 .x_ebcb5a8d {
  color: #484848;
}
#element-729 .x_9e1789bd {
  text-align: left;
  caret-color: rgb(72, 72, 72);
}
#element-723 {
  top: 18.6875rem;
  left: 1.25rem;
  height: 1.6875rem;
  width: 22.5rem;
  z-index: 63;
  color: #98a0a6;
  font-size: 1.0526rem;
  line-height: 1.7rem;
  text-align: center;
}
#element-723 .x_7a88b5a4 {
  text-align: center;
  line-height: 1.6875rem;
  font-size: 1.0526rem;
}
#element-723 .x_c3ede868 {
  color: #32174d;
}
#element-724 {
  top: 25.875rem;
  left: 3.625rem;
  height: auto;
  width: 17.75rem;
  z-index: 99;
  color: #98a0a6;
  font-size: 1.0526rem;
  line-height: 1.7rem;
  text-align: center;
}
#element-724 .x_7a88b5a4 {
  text-align: center;
  line-height: 1.6875rem;
  font-size: 1.0526rem;
}
#element-724 .x_9e1789bd {
  text-align: left;
  caret-color: rgb(72, 72, 72);
}
#element-724 .x_c3ede868 {
  color: #32174d;
}
#element-725 {
  top: 39.9375rem;
  left: 1.6875rem;
  height: 1.6875rem;
  width: 22.0625rem;
  z-index: 100;
  color: #98a0a6;
  font-size: 1.0526rem;
  line-height: 1.7rem;
  text-align: center;
}
#element-725 .x_7a88b5a4 {
  text-align: center;
  line-height: 1.6875rem;
  font-size: 1.0526rem;
}
#element-725 .x_c3ede868 {
  color: #32174d;
}
#element-725 .x_9e1789bd {
  text-align: left;
  caret-color: rgb(72, 72, 72);
}
#element-725 strong {
  font-weight: 700;
}
#element-717 {
  top: 21rem;
  left: 1.6875rem;
  height: auto;
  width: 22.0625rem;
  z-index: 33;
  color: #98a0a6;
  font-size: 1.0526rem;
  line-height: 1.4875rem;
  text-align: center;
}
#element-717 .x_8642b94b {
  text-align: center;
  line-height: 1.2rem;
  font-size: 1.0526rem;
}
#element-717 .x_ebcb5a8d {
  color: #484848;
}
#element-717 .x_9e1789bd {
  text-align: left;
  caret-color: rgb(72, 72, 72);
}
#element-719 {
  top: 31.1875rem;
  left: 0.875rem;
  height: auto;
  width: 23.125rem;
  z-index: 55;
  color: #98a0a6;
  font-size: 1.0526rem;
  line-height: 1.7rem;
  text-align: center;
}
#element-719 .x_7a88b5a4 {
  text-align: center;
  line-height: 1.6875rem;
  font-size: 1.0526rem;
}
#element-719 .x_ebcb5a8d {
  color: #484848;
}
#element-719 .x_9e1789bd {
  text-align: left;
  caret-color: rgb(72, 72, 72);
}
#element-718 {
  top: 42.1875rem;
  left: 1.6875rem;
  height: 3.375rem;
  width: 22.0625rem;
  z-index: 53;
  color: #98a0a6;
  font-size: 1.0526rem;
  line-height: 1.7rem;
  text-align: center;
}
#element-718 .x_7a88b5a4 {
  text-align: center;
  line-height: 1.6875rem;
  font-size: 1.0526rem;
}
#element-718 .x_ebcb5a8d {
  color: #484848;
}
#element-718 .x_9e1789bd {
  text-align: left;
  caret-color: rgb(72, 72, 72);
}
#element-726 {
  top: 46.3125rem;
  left: 1.6875rem;
  height: auto;
  width: 22.0625rem;
  z-index: 113;
  color: #98a0a6;
  font-size: 1.0526rem;
  line-height: 1.7rem;
  text-align: center;
}
#element-726 .x_7a88b5a4 {
  text-align: center;
  line-height: 1.6875rem;
  font-size: 1.0526rem;
}
#element-726 .x_9e1789bd {
  text-align: left;
  caret-color: rgb(72, 72, 72);
}
#element-726 .x_c3ede868 {
  color: #32174d;
}
#element-727 {
  top: 55.625rem;
  left: 1.6875rem;
  height: 1.6875rem;
  width: 22.0625rem;
  z-index: 116;
  color: #98a0a6;
  font-size: 1.0526rem;
  line-height: 1.7rem;
  text-align: center;
}
#element-727 .x_7a88b5a4 {
  text-align: center;
  line-height: 1.6875rem;
  font-size: 1.0526rem;
}
#element-727 .x_9e1789bd {
  text-align: left;
  caret-color: rgb(72, 72, 72);
}
#element-727 .x_c3ede868 {
  color: #32174d;
}
#element-728 {
  top: 65.875rem;
  left: 1.6875rem;
  height: 1.6875rem;
  width: 22.0625rem;
  z-index: 122;
  color: #98a0a6;
  font-size: 1.0526rem;
  line-height: 1.7rem;
  text-align: center;
}
#element-728 .x_7a88b5a4 {
  text-align: center;
  line-height: 1.6875rem;
  font-size: 1.0526rem;
}
#element-728 .x_9e1789bd {
  text-align: left;
  caret-color: rgb(72, 72, 72);
}
#element-728 .x_c3ede868 {
  color: #32174d;
}
#element-721 {
  top: 49.6875rem;
  left: 1.6875rem;
  height: auto;
  width: 22.0625rem;
  z-index: 60;
  color: #98a0a6;
  font-size: 1.0526rem;
  line-height: 1.7rem;
  text-align: center;
}
#element-721 .x_7a88b5a4 {
  text-align: center;
  line-height: 1.6875rem;
  font-size: 1.0526rem;
}
#element-721 .x_ebcb5a8d {
  color: #484848;
}
#element-721 .x_9e1789bd {
  text-align: left;
  caret-color: rgb(72, 72, 72);
}
#element-720 {
  top: 57.9375rem;
  left: 1.6875rem;
  height: auto;
  width: 22.0625rem;
  z-index: 101;
  color: #98a0a6;
  font-size: 1.0526rem;
  line-height: 1.7rem;
  text-align: center;
}
#element-720 .x_7a88b5a4 {
  text-align: center;
  line-height: 1.6875rem;
  font-size: 1.0526rem;
}
#element-720 .x_ebcb5a8d {
  color: #484848;
}
#element-720 .x_9e1789bd {
  text-align: left;
  caret-color: rgb(72, 72, 72);
}
#element-722 {
  top: 68.125rem;
  left: 1.6875rem;
  height: auto;
  width: 22.0625rem;
  z-index: 102;
  color: #98a0a6;
  font-size: 1.0526rem;
  line-height: 1.7rem;
  text-align: center;
}
#element-722 .x_7a88b5a4 {
  text-align: center;
  line-height: 1.6875rem;
  font-size: 1.0526rem;
}
#element-722 .x_ebcb5a8d {
  color: #484848;
}
#element-722 .x_9e1789bd {
  text-align: left;
  caret-color: rgb(72, 72, 72);
}
#page-block-sfatg4kg7c {
  height: 42.8125rem;
  max-width: 100%;
}
#page-block-sfatg4kg7c .section-holder-border {
  border: 0;
}
#page-block-sfatg4kg7c .section-block {
  background: rgb(249, 249, 249);
  height: 42.8125rem;
}
#page-block-sfatg4kg7c .section-holder-overlay {
  display: none;
}
#element-734 {
  top: 2.75rem;
  left: 1.5rem;
  height: 1.8125rem;
  width: 21.75rem;
  z-index: 13;
  color: #98a0a6;
  font-size: 1.4861rem;
  line-height: 1.8rem;
  text-align: center;
}
#element-734 .x_5f0ed501 {
  text-align: center;
  line-height: 1.8125rem;
  font-size: 1.4861rem;
}
#element-734 .x_ebcb5a8d {
  color: #484848;
}
#element-734 .x_9e1789bd {
  text-align: left;
  caret-color: rgb(72, 72, 72);
}
#element-735 {
  top: 6.875rem;
  left: 1.375rem;
  height: 3rem;
  width: 3rem;
  z-index: 78;
}
#element-736 {
  top: 7.4375rem;
  left: 5.375rem;
  height: 1.875rem;
  width: 8.5625rem;
  z-index: 79;
  color: #98a0a6;
  font-size: 1.1765rem;
  line-height: 1.9rem;
  text-align: left;
}
#element-736 .x_9bc23194 {
  text-align: left;
  line-height: 1.875rem;
  font-size: 1.1765rem;
}
#element-736 .x_ebcb5a8d {
  color: #484848;
}
#element-737 {
  top: 10.375rem;
  left: 1.375rem;
  height: 5.0625rem;
  width: 22rem;
  z-index: 80;
  color: #98a0a6;
  font-size: 1.0526rem;
  line-height: 1.7rem;
  text-align: left;
}
#element-737 .x_390ad34e {
  text-align: left;
  line-height: 1.6875rem;
  font-size: 1.0526rem;
}
#element-737 .x_ebcb5a8d {
  color: #484848;
}
#element-737 .x_9e1789bd {
  text-align: left;
  caret-color: rgb(72, 72, 72);
}
#element-738 {
  top: 17.375rem;
  left: 1.4375rem;
  height: 3rem;
  width: 3.0625rem;
  z-index: 45;
}
#element-739 {
  top: 17.9375rem;
  left: 5.4375rem;
  height: 1.875rem;
  width: 8.5625rem;
  z-index: 46;
  color: #98a0a6;
  font-size: 1.1765rem;
  line-height: 1.9rem;
  text-align: left;
}
#element-739 .x_9bc23194 {
  text-align: left;
  line-height: 1.875rem;
  font-size: 1.1765rem;
}
#element-739 .x_ebcb5a8d {
  color: #484848;
}
#element-740 {
  top: 20.8125rem;
  left: 1.4375rem;
  height: 8.4375rem;
  width: 22rem;
  z-index: 47;
  color: #98a0a6;
  font-size: 1.0526rem;
  line-height: 1.7rem;
  text-align: left;
}
#element-740 .x_390ad34e {
  text-align: left;
  line-height: 1.6875rem;
  font-size: 1.0526rem;
}
#element-740 .x_ebcb5a8d {
  color: #484848;
}
#element-740 .x_9e1789bd {
  text-align: left;
  caret-color: rgb(72, 72, 72);
}
#element-741 {
  top: 36.75rem;
  left: 1.25rem;
  height: 2.7692rem;
  width: 3rem;
  z-index: 57;
}
#element-742 {
  top: 36.75rem;
  left: 5.25rem;
  height: 1.875rem;
  width: 8.5625rem;
  z-index: 58;
  color: #98a0a6;
  font-size: 1.1765rem;
  line-height: 1.9rem;
  text-align: left;
}
#element-742 .x_9bc23194 {
  text-align: left;
  line-height: 1.875rem;
  font-size: 1.1765rem;
}
#element-742 .x_ebcb5a8d {
  color: #484848;
}
#element-743 {
  top: 39.3125rem;
  left: 1.25rem;
  height: 5.0625rem;
  width: 22rem;
  z-index: 59;
  color: #98a0a6;
  font-size: 1.0526rem;
  line-height: 1.7rem;
  text-align: left;
}
#element-743 .x_390ad34e {
  text-align: left;
  line-height: 1.6875rem;
  font-size: 1.0526rem;
}
#element-743 .x_ebcb5a8d {
  color: #484848;
}
#element-743 .x_9e1789bd {
  text-align: left;
  caret-color: rgb(72, 72, 72);
}
#element-745 {
  top: -286.375rem;
  left: 1.25rem;
  height: 1.375rem;
  width: 22.5rem;
  z-index: 73;
  display: none;
}
#element-745 .shape {
  border-bottom: 2px dashed #8b63a7;
}
#element-746 {
  top: -286.375rem;
  left: 4.5rem;
  height: 1.375rem;
  width: 15.9375rem;
  z-index: 81;
}
#element-746 .shape {
  border-bottom: 2px solid #8b63a7;
}
#element-747 {
  top: -286.375rem;
  left: 4.5rem;
  height: 1.375rem;
  width: 15.9375rem;
  z-index: 82;
}
#element-747 .shape {
  border-bottom: 2px solid #8b63a7;
}
#element-744 {
  top: -286.375rem;
  left: 1.25rem;
  height: 1.375rem;
  width: 22.5rem;
  z-index: 69;
}
#element-744 .shape {
  border-bottom: 2px dashed #8b63a7;
}
#page-block-7peatp556bf {
  height: 111.8125rem;
  max-width: 100%;
}
#page-block-7peatp556bf .section-holder-border {
  border: 0;
}
#page-block-7peatp556bf .section-block {
  background: none;
  height: 111.8125rem;
}
#page-block-7peatp556bf .section-holder-overlay {
  display: none;
}
#element-790 {
  top: 3.5rem;
  left: 1.5rem;
  height: 2.125rem;
  width: 21.9375rem;
  z-index: 43;
  color: #98a0a6;
  font-size: 1.7337rem;
  line-height: 2.1rem;
  text-align: center;
}
#element-790 .x_446dab97 {
  text-align: center;
  line-height: 2.125rem;
  font-size: 1.7337rem;
}
#element-790 .x_ebcb5a8d {
  color: #484848;
}
#element-790 .x_9e1789bd {
  text-align: left;
  caret-color: rgb(72, 72, 72);
}
#element-791 {
  top: 6.125rem;
  left: 1.5rem;
  height: 3rem;
  width: 21.9375rem;
  z-index: 44;
  color: #98a0a6;
  font-size: 1.0526rem;
  line-height: 1.4875rem;
  text-align: center;
}
#element-791 .x_8642b94b {
  text-align: center;
  line-height: 1.5rem;
  font-size: 1.0526rem;
}
#element-791 .x_ebcb5a8d {
  color: #484848;
}
#element-791 .x_9e1789bd {
  text-align: left;
  caret-color: rgb(72, 72, 72);
}
#element-798 {
  top: 13.125rem;
  left: 1.4375rem;
  height: 12.5rem;
  width: 22.0625rem;
  z-index: 61;
}
#element-798 .shape {
  border: 0;
  border-radius: 0 0 0 0;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM89h8AApEBx2iaqpQAAAAASUVORK5CYII=)
    repeat rgb(240, 243, 245) 53% 37% / cover;
}
#element-792 {
  top: 43.8125rem;
  left: 1.4375rem;
  height: 12.5rem;
  width: 21.9375rem;
  z-index: 68;
}
#element-792 .shape {
  border: 0;
  border-radius: 0 0 0 0;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM89h8AApEBx2iaqpQAAAAASUVORK5CYII=)
    repeat rgb(240, 243, 245) 50% 50% / cover;
}
#element-799 {
  top: 76.6875rem;
  left: 1.4375rem;
  height: 12.5rem;
  width: 21.9375rem;
  z-index: 89;
}
#element-799 .shape {
  border: 0;
  border-radius: 0 0 0 0;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM89h8AApEBx2iaqpQAAAAASUVORK5CYII=)
    repeat rgb(240, 243, 245) 50% 50% / cover;
}
#element-793 {
  top: 22.9375rem;
  left: 2.25rem;
  height: 1.6875rem;
  width: 17.1875rem;
  z-index: 64;
  color: #98a0a6;
  font-size: 1.0526rem;
  line-height: 1.7rem;
  text-align: left;
}
#element-793 .x_390ad34e {
  text-align: left;
  line-height: 1.6875rem;
  font-size: 1.0526rem;
}
#element-793 .x_f2074b6c {
  color: #333;
}
#element-793 .x_9e1789bd {
  text-align: left;
  caret-color: rgb(72, 72, 72);
}
#element-794 {
  top: 52.8125rem;
  left: 2.4375rem;
  height: auto;
  width: 17.0625rem;
  z-index: 71;
  color: #98a0a6;
  font-size: 1.0526rem;
  line-height: 1.7rem;
  text-align: left;
}
#element-794 .x_390ad34e {
  text-align: left;
  line-height: 1.6875rem;
  font-size: 1.0526rem;
}
#element-794 .x_f2074b6c {
  color: #333;
}
#element-794 .x_9e1789bd {
  text-align: left;
  caret-color: rgb(72, 72, 72);
}
#element-800 {
  top: 86.5rem;
  left: 2.375rem;
  height: 1.6875rem;
  width: 17.25rem;
  z-index: 95;
  color: #98a0a6;
  font-size: 1.0526rem;
  line-height: 1.7rem;
  text-align: left;
}
#element-800 .x_390ad34e {
  text-align: left;
  line-height: 1.6875rem;
  font-size: 1.0526rem;
}
#element-800 .x_f2074b6c {
  color: #333;
}
#element-800 .x_9e1789bd {
  text-align: left;
  caret-color: rgb(72, 72, 72);
}
#element-805 {
  top: 65.5rem;
  left: 1.4375rem;
  height: 1.375rem;
  width: 22rem;
  z-index: 133;
}
#element-805 .shape {
  border-bottom: 2px solid #f0f3f5;
}
#element-802 {
  top: 35.625rem;
  left: 1.6875rem;
  height: 1.375rem;
  width: 21.75rem;
  z-index: 128;
}
#element-802 .shape {
  border-bottom: 2px solid #f0f3f5;
}
#element-808 {
  top: 99.8125rem;
  left: 1.4375rem;
  height: 1.5rem;
  width: 22rem;
  z-index: 138;
}
#element-808 .shape {
  border-bottom: 4px solid #f0f3f5;
}
#element-795 {
  top: 29.625rem;
  left: 4.375rem;
  height: 4.25rem;
  width: 16.4375rem;
  z-index: 125;
  color: #98a0a6;
  font-size: 1.4861rem;
  line-height: 2.1rem;
  text-align: center;
}
#element-795 .x_fc9d998b {
  text-align: center;
  line-height: 2.125rem;
  font-size: 1.4861rem;
}
#element-795 .x_ebcb5a8d {
  color: #484848;
}
#element-795 .x_9e1789bd {
  text-align: left;
  caret-color: rgb(72, 72, 72);
}
#element-804 {
  top: 59.1875rem;
  left: 4.9375rem;
  height: 4.5rem;
  width: 14.9375rem;
  z-index: 132;
  color: #98a0a6;
  font-size: 1.6099rem;
  line-height: 2.275rem;
  text-align: center;
}
#element-804 .x_47b745f5 {
  text-align: center;
  line-height: 2.25rem;
  font-size: 1.6099rem;
}
#element-804 .x_ebcb5a8d {
  color: #484848;
}
#element-804 .x_9e1789bd {
  text-align: left;
  caret-color: rgb(72, 72, 72);
}
#element-807 {
  top: 92.625rem;
  left: 4.9375rem;
  height: 5.4375rem;
  width: 14.9375rem;
  z-index: 137;
  color: #98a0a6;
  font-size: 1.4861rem;
  line-height: 1.8rem;
  text-align: center;
}
#element-807 .x_5f0ed501 {
  text-align: center;
  line-height: 1.8125rem;
  font-size: 1.4861rem;
}
#element-807 .x_ebcb5a8d {
  color: #484848;
}
#element-807 .x_9e1789bd {
  text-align: left;
  caret-color: rgb(72, 72, 72);
}
#element-806 {
  top: 57.3125rem;
  left: 1.4375rem;
  height: 1.375rem;
  width: 22rem;
  z-index: 134;
}
#element-806 .shape {
  border-bottom: 2px solid #f0f3f5;
}
#element-803 {
  top: 27.375rem;
  left: 1.6875rem;
  height: 1.375rem;
  width: 21.75rem;
  z-index: 130;
}
#element-803 .shape {
  border-bottom: 2px solid #f0f3f5;
}
#element-809 {
  top: 90.25rem;
  left: 1.4375rem;
  height: 1.5rem;
  width: 22rem;
  z-index: 139;
}
#element-809 .shape {
  border-bottom: 4px solid #f0f3f5;
}
#element-801 {
  top: 36.5625rem;
  left: 1.6875rem;
  height: 3.375rem;
  width: 21.75rem;
  z-index: 126;
  color: #98a0a6;
  font-size: 1.0526rem;
  line-height: 1.7rem;
  text-align: center;
}
#element-801 .x_7a88b5a4 {
  text-align: center;
  line-height: 1.6875rem;
  font-size: 1.0526rem;
}
#element-801 .x_ebcb5a8d {
  color: #484848;
}
#element-801 .x_9e1789bd {
  text-align: left;
  caret-color: rgb(72, 72, 72);
}
#element-796 {
  top: 67.125rem;
  left: 1.4375rem;
  height: auto;
  width: 21.9375rem;
  z-index: 131;
  color: #98a0a6;
  font-size: 1.0526rem;
  line-height: 1.7rem;
  text-align: center;
}
#element-796 .x_7a88b5a4 {
  text-align: center;
  line-height: 1.6875rem;
  font-size: 1.0526rem;
}
#element-796 .x_ebcb5a8d {
  color: #484848;
}
#element-796 .x_9e1789bd {
  text-align: left;
  caret-color: rgb(72, 72, 72);
}
#element-797 {
  top: 101.3125rem;
  left: 1.4375rem;
  height: 8.4375rem;
  width: 22rem;
  z-index: 135;
  color: #98a0a6;
  font-size: 1.0526rem;
  line-height: 1.7rem;
  text-align: center;
}
#element-797 .x_7a88b5a4 {
  text-align: center;
  line-height: 1.6875rem;
  font-size: 1.0526rem;
}
#element-797 .x_ebcb5a8d {
  color: #484848;
}
#element-797 .x_9e1789bd {
  text-align: left;
  caret-color: rgb(72, 72, 72);
}
#page-block-74qk0seeq8 {
  height: 47.3125rem;
  max-width: 100%;
}
#page-block-74qk0seeq8 .section-holder-border {
  border: 0;
}
#page-block-74qk0seeq8 .section-block {
  background: rgb(255, 255, 255);
  height: 47.3125rem;
}
#page-block-74qk0seeq8 .section-holder-overlay {
  display: none;
}
#element-243 {
  top: 0;
  left: 1.25rem;
  height: 33rem;
  width: 22.375rem;
  z-index: 21;
}
#element-243 .shape {
  border: 0.0625rem solid #a3bac6;
  background: rgb(249, 249, 249);
}
#element-243 .contents {
  font-family: Open Sans !important;
  font-weight: 400 !important;
  background-color: rgb(249, 249, 249) !important;
  border-radius: 0px !important;
  border-color: rgb(163, 186, 198) !important;
  border-width: 0 !important;
  border-style: solid !important;
  background-repeat: repeat !important;
  background-position: center !important;
  background-size: cover !important;
}
#element-236 {
  top: 2.375rem;
  left: 2.4375rem;
  height: auto;
  width: 20rem;
  z-index: 23;
}
.video-holder {
  height: 100%;
  overflow: hidden;
  position: relative;
}
.video-holder-animoto {
  background-color: #000;
}
.video-animoto {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
  margin: auto;
}
.video-iframe {
  position: absolute;
}
.video-overlay:hover {
  opacity: 1;
}
.video-holder-helpers {
  transition: opacity 0.15s ease-in-out;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  font-size: 14px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.video-overlay {
  background-color: rgba(31, 59, 82, 0.8);
  color: #ffffff;
  opacity: 0;
  z-index: 1;
}
.warning-text {
  margin-top: 10px;
  font-size: 13px;
}
.warning-img {
  width: 25px;
}
.fake-video {
  background: #ffffff;
}
.fake-play {
  opacity: 0.8;
}
.video-overlay:hover ~ .fake-play {
  opacity: 0;
}
#element-236 iframe {
  width: 320px;
  height: 208px;
}
#element-237 {
  top: 25.375rem;
  left: 2.4375rem;
  height: auto;
  width: 20rem;
  z-index: 25;
}
#element-237 iframe {
  width: 320px;
  height: 208px;
}
#page_block_header {
  height: 75rem;
  max-width: 100%;
}
#page_block_header .section-holder-border {
  border: 0;
}
#page_block_header .section-block {
  background: none;
  height: 75rem;
}
#page_block_header .section-holder-overlay {
  display: none;
}
#element-385 {
  top: 4.5rem;
  left: 4.5rem;
  height: 15.8125rem;
  width: 15.8125rem;
  z-index: 54;
}
#element-385 .shape {
  border: 0.0625rem solid #a3bac6;
  border-radius: 0.4375rem 0.4375rem 0.4375rem 0.4375rem;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM89h8AApEBx2iaqpQAAAAASUVORK5CYII=)
    repeat rgb(240, 243, 245) 50% 50% / cover;
}
#element-386 {
  top: 27rem;
  left: 4.4375rem;
  height: 15.8125rem;
  width: 16.125rem;
  z-index: 62;
}
#element-386 .shape {
  border: 0.0625rem solid #a3bac6;
  border-radius: 0.4375rem 0.4375rem 0.4375rem 0.4375rem;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM89h8AApEBx2iaqpQAAAAASUVORK5CYII=)
    repeat rgb(240, 243, 245) 50% 50% / cover;
}
#element-387 {
  top: 51rem;
  left: 4.4375rem;
  height: 15.8125rem;
  width: 16.125rem;
  z-index: 65;
}
#element-387 .shape {
  border: 0.0625rem solid #a3bac6;
  border-radius: 0.4375rem 0.4375rem 0.4375rem 0.4375rem;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM89h8AApEBx2iaqpQAAAAASUVORK5CYII=)
    repeat rgb(240, 243, 245) 50% 50% / cover;
}
#element-471 {
  top: 21rem;
  left: 4.5rem;
  height: 3rem;
  width: 15.9375rem;
  z-index: 66;
  color: #37465a;
  font-size: 0.9288rem;
  line-height: 1.5rem;
  text-align: center;
}
#element-471 .x_519e17eb {
  text-align: center;
  line-height: 1.5rem;
  font-size: 0.9288rem;
}
#element-471 .x_ebcb5a8d {
  color: #484848;
}
#element-472 {
  top: 43.5rem;
  left: 4.4375rem;
  height: 4.5rem;
  width: 16.0625rem;
  z-index: 67;
  color: #37465a;
  font-size: 0.9288rem;
  line-height: 1.5rem;
  text-align: center;
}
#element-472 .x_519e17eb {
  text-align: center;
  line-height: 1.5rem;
  font-size: 0.9288rem;
}
#element-472 .x_ebcb5a8d {
  color: #484848;
}
#element-473 {
  top: 67.5rem;
  left: 4.5rem;
  height: 3rem;
  width: 16.0625rem;
  z-index: 72;
  color: #37465a;
  font-size: 0.9288rem;
  line-height: 1.5rem;
  text-align: center;
}
#element-473 .x_519e17eb {
  text-align: center;
  line-height: 1.5rem;
  font-size: 0.9288rem;
}
#element-473 .x_ebcb5a8d {
  color: #484848;
}
#page-block-nig0x1pdc3a {
  height: 58rem;
  max-width: 100%;
}
#page-block-nig0x1pdc3a .section-holder-border {
  border: 0;
}
#page-block-nig0x1pdc3a .section-block {
  background: url(//v.fastcdn.co/u/8f6a85c1/49485940-0-Footer-BG.png) repeat 50%
    0 / cover;
  height: 58rem;
}
#page-block-nig0x1pdc3a .section-holder-overlay {
  display: none;
}
#element-670 {
  top: 18.9375rem;
  left: 11rem;
  height: 1.625rem;
  width: 2.8125rem;
  z-index: 74;
}
#element-670 .shape {
  border-bottom: 6px solid #ffffff;
}
#element-666 {
  top: 4.5rem;
  left: 2.9375rem;
  height: 12.2692rem;
  width: 19.25rem;
  z-index: 48;
}
#element-666 .cropped {
  background: url(//v.fastcdn.co/u/8f6a85c1/49486060-0-ss.svg) 0 -0.0625rem /
    19.375rem 12.3125rem;
}
#element-667 {
  top: 21.5625rem;
  left: 1.25rem;
  height: 1.9375rem;
  width: 22.5rem;
  z-index: 49;
  color: #37465a;
  font-size: 1.3622rem;
  line-height: 1.925rem;
  text-align: center;
}
#element-667 .x_eced8c99 {
  text-align: center;
  line-height: 1.9375rem;
  font-size: 1.3622rem;
}
#element-667 .x_f2074b6c {
  color: #ffffff;
}
#element-668 {
  top: 26.4375rem;
  left: 1.1875rem;
  height: 2.75rem;
  width: 22.5rem;
  z-index: 50;
  color: #37465a;
  font-size: 0.9907rem;
  line-height: 1.4rem;
  text-align: center;
}
#element-668 .x_7e43f367 {
  text-align: center;
  line-height: 1.375rem;
  font-size: 0.9907rem;
}
#element-668 .x_f2074b6c {
  color: #ffffff;
}
#element-669 {
  top: 30.6875rem;
  left: 1.5rem;
  height: 3.5rem;
  width: 21.5625rem;
  z-index: 51;
}
#element-669 .btn.btn-effect3d:active {
  box-shadow: none;
}
#element-669 .btn:hover {
  background: #12e4b5;
  color: #ffffff;
}
#element-669 .btn {
  background: #0cdaac;
  color: #ffffff;
  font-size: 1.1765rem;
  font-family: Prompt;
  font-weight: 400;
  font-style: normal;
  height: 3.5rem;
  width: 21.5625rem;
  border-radius: 3px;
}
#element-659 {
  top: 39.1875rem;
  left: 1.5rem;
  height: 1.3125rem;
  width: 21.8125rem;
  z-index: 52;
}
#element-659 .shape {
  border-bottom: 1px solid #ffffff;
}
#element-664 {
  top: 46.0625rem;
  left: 1.5rem;
  height: 4.25rem;
  width: 22.0625rem;
  z-index: 96;
}
#element-664 .shape {
  border: 0;
  border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
  background: rgb(70, 46, 95);
}
#element-662 {
  top: 46.0625rem;
  left: 1.5rem;
  height: 4.5rem;
  width: 16rem;
  z-index: 97;
}
#element-662 .btn.btn-effect3d:active {
  box-shadow: none;
}
#element-662 .btn:hover {
  background: transparent;
  color: #ffffff;
}
#element-662 .btn {
  color: #ffffff;
  font-size: 0.9907rem;
  font-family: "Open Sans";
  font-weight: 700;
  font-style: normal;
  height: 2.9375rem;
  width: 6rem;
  border-radius: 3px;
}
#element-662 .form-label {
  color: #dad5df;
}
#element-662 ::placeholder {
  color: #dad5df;
}
#element-662 .form-input {
  color: #ffffff;
}
#element-662 .form-select[aria-invalid="false"] {
  color: #ffffff;
}
#element-662 .user-invalid {
  border-color: #e12627;
}
#element-662 input::placeholder,
#element-662 .form-label-inside {
  color: #dad5df;
}
#element-662 select.valid {
  color: #ffffff;
}
#element-662 .form-btn-geometry {
  top: 0.8125rem;
  left: 16rem;
  height: 2.9375rem;
  width: 6rem;
  z-index: 97;
}
#element-665 {
  top: 43.5625rem;
  left: 3.4375rem;
  height: 1.625rem;
  width: 18.25rem;
  z-index: 70;
  color: #37465a;
  font-size: 0.9907rem;
  line-height: 1.6rem;
  text-align: center;
}
#element-665 .x_ebb3d042 {
  text-align: center;
  line-height: 1.625rem;
  font-size: 0.9907rem;
}
#element-665 .x_f2074b6c {
  color: #ffffff;
}
#element-671 {
  top: 29.4375rem;
  left: 32.8125rem;
  height: 2.5rem;
  width: 1.3125rem;
  z-index: 98;
}
#element-671 .shape {
  border-right: 1px solid #dad5df;
}
#element-660 {
  top: 43.625rem;
  left: 1.5rem;
  height: 1.375rem;
  width: 21.75rem;
  z-index: 56;
  color: #37465a;
  font-size: 0.8669rem;
  line-height: 1.4rem;
  text-align: center;
}
#element-660 .x_938e8cfc {
  text-align: center;
  line-height: 1.375rem;
  font-size: 0.8669rem;
}
#element-660 .x_f2074b6c {
  color: #ffffff;
}
@media screen and (max-width: 400px) {
  :root {
    font-size: 4vw;
  }
  :root.js-text-scaling {
    font-size: var(--mobile-font-size);
  }
}
@media screen and (min-width: 401px) and (max-width: 767px) {
  :root {
    font-size: 16px;
  }
  :root.js-text-scaling {
    font-size: var(--default-font-size);
  }
}
@media screen and (min-width: 768px) and (max-width: 1200px) {
  :root {
    font-size: 1.33vw;
  }
}
@media screen and (min-width: 768px) and (max-width: 7680px) {
  .hidden-desktop {
    display: none;
  }
}
@media screen and (max-width: 767px) {
  .hidden-mobile {
    display: none;
  }
  .sticky-block-header-onlyonmobile .section:first-child,
  .sticky-block-footer-onlyonmobile .section:last-child {
    position: sticky;
  }
}
@media screen and (min-width: 768px) {
  .section-fit {
    max-width: 60rem;
    overflow: hidden;
  }
  .sticky-block-header-onlyondesktop .section:first-child,
  .sticky-block-footer-onlyondesktop .section:last-child {
    position: sticky;
  }
  #page-block-gy1aig4hdp {
    height: 66.5rem;
    max-width: 100%;
  }
  #page-block-gy1aig4hdp .section-holder-border {
    border: 0;
  }
  #page-block-gy1aig4hdp .section-block {
    background-repeat: no-repeat; /* 防止图片在容器较宽时出现平铺 */
    background-color: rgb(255, 255, 255);
    background-position: center center;
    /* background-image: url("./main_bg.jpg"); */
    background-size: contain;
    height: 86.5rem;
  }
  #page-block-gy1aig4hdp .section-holder-overlay {
    display: none;
  }
  #element-552 {
    top: 2.9375rem;
    left: 0;
    height: 4.25rem;
    width: 4.25rem;
    z-index: 75;
  }
  #element-817 {
    top: 7rem;
    left: 0.0625rem;
    height: 2.625rem;
    width: 21.3125rem;
    z-index: 152;
    color: #fff;
    font-size: 1.6099rem;
    line-height: 2.6rem;
    text-align: left;
  }
  #element-817 .x_f4b5a1e3 {
    text-align: left;
    line-height: 2.625rem;
    font-size: 1.6099rem;
  }
  #element-817 .x_c3ede868 {
    color: #fff;
  }
  #element-541 {
    top: 10rem;
    left: 0;
    height: 7rem;
    width: 29.5625rem;
    z-index: 29;
    color: #37465a;
    font-size: 2.9102rem;
    line-height: 3.525rem;
    text-align: left;
  }
  #element-541 .x_8181b8a8 {
    text-align: left;
    line-height: 3.5rem;
    font-size: 2.9102rem;
  }
  #element-541 .x_c3ede868 {
    color: #fff;
  }
  #element-542 {
    top: 27.75rem;
    left: -0.25rem;
    height: 2.625rem;
    width: 25.875rem;
    z-index: 31;
    color: #37465a;
    font-size: 1.6099rem;
    line-height: 2.6rem;
    text-align: left;
  }
  #element-542 .x_f4b5a1e3 {
    text-align: left;
    line-height: 2.625rem;
    font-size: 1.6099rem;
  }
  #element-542 .x_c3ede868 {
    color: #fff;
  }
  #element-540 {
    top: 35.5rem;
    left: 0;
    height: 2.5rem;
    width: 9rem;
    z-index: 32;
  }
  #element-540 .btn.btn-effect3d:active {
    box-shadow: none;
  }
  #element-540 .btn:hover {
    background: #06d4a6;
    color: #ffffff;
  }
  #element-540 .btn {
    background: #0cdaac;
    color: #ffffff;
    font-size: 0.9907rem;
    font-family: Prompt;
    font-weight: 400;
    font-style: normal;
    height: 2.5rem;
    width: 9rem;
    border-radius: 3px;
  }
  #element-539 {
    top: 53.75rem;
    left: -3.5625rem;
    height: 12.6875rem;
    width: 24.75rem;
    z-index: 27;
  }
  #element-544 {
    top: 58.625rem;
    left: 0;
    height: 6.0625rem;
    width: 6rem;
    z-index: 35;
  }
  #page-block-aq16osz343o {
    height: 7.4375rem;
    max-width: 100%;
  }
  #page-block-aq16osz343o .section-holder-border {
    border: 0;
  }
  #page-block-aq16osz343o .section-block {
    background: rgb(249, 249, 249);
    height: 7.4375rem;
  }
  #page-block-aq16osz343o .section-holder-overlay {
    display: none;
  }
  #page-block-aq16osz343o .headline {
    font-family: Prompt;
    font-weight: 600;
  }
  #page-block-aq16osz343o .paragraph {
    font-family: Prompt;
    font-weight: 300;
  }
  #page-block-aq16osz343o .btn {
    font-family: Prompt;
  }
  #element-__gpage-block-aq16osz343o-822 {
    top: 3.125rem;
    left: 0.3125rem;
    height: 1.625rem;
    width: 1.625rem;
    z-index: 83;
  }
  #element-__gpage-block-aq16osz343o-822 .shape {
    border: 0;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM89h8AApEBx2iaqpQAAAAASUVORK5CYII=)
      no-repeat 50% 50% / auto;
  }
  #element-__gpage-block-aq16osz343o-823 {
    top: 3.125rem;
    left: 2.5rem;
    height: 1.9375rem;
    width: 16.125rem;
    z-index: 84;
    color: #37465a;
    font-size: 1.3622rem;
    line-height: 1.925rem;
    text-align: left;
    font-weight: 700;
  }
  #element-__gpage-block-aq16osz343o-823 .x_052b6b4c {
    text-align: left;
    line-height: 1.9375rem;
    font-size: 1.3622rem;
  }
  #element-__gpage-block-aq16osz343o-823 strong {
    font-weight: 700;
  }
  #element-__gpage-block-aq16osz343o-823.headline {
    font-weight: 700;
  }
  #element-__gpage-block-aq16osz343o-824 {
    top: 3.125rem;
    left: 20.3125rem;
    height: 1.625rem;
    width: 1.625rem;
    z-index: 139;
  }
  #element-__gpage-block-aq16osz343o-824 .shape {
    border: 0;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM89h8AApEBx2iaqpQAAAAASUVORK5CYII=)
      no-repeat 50% 50% / auto;
  }
  #element-__gpage-block-aq16osz343o-825 {
    top: 3.125rem;
    left: 22.5rem;
    height: 1.9375rem;
    width: 17.5rem;
    z-index: 140;
    color: #37465a;
    font-size: 1.3622rem;
    line-height: 1.925rem;
    text-align: left;
    font-weight: 700;
  }
  #element-__gpage-block-aq16osz343o-825 .x_052b6b4c {
    text-align: left;
    line-height: 1.9375rem;
    font-size: 1.3622rem;
  }
  #element-__gpage-block-aq16osz343o-825 strong {
    font-weight: 700;
  }
  #element-__gpage-block-aq16osz343o-825.headline {
    font-weight: 700;
  }
  #element-__gpage-block-aq16osz343o-826 {
    top: 3.125rem;
    left: 41.5625rem;
    height: 1.625rem;
    width: 1.625rem;
    z-index: 146;
  }
  #element-__gpage-block-aq16osz343o-826 .shape {
    border: 0;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM89h8AApEBx2iaqpQAAAAASUVORK5CYII=)
      no-repeat 50% 50% / auto;
  }
  #element-__gpage-block-aq16osz343o-827 {
    top: 3.125rem;
    left: 43.4375rem;
    height: 1.9375rem;
    width: 16.25rem;
    z-index: 149;
    color: #37465a;
    font-size: 1.3622rem;
    line-height: 1.925rem;
    text-align: left;
    font-weight: 700;
  }
  #element-__gpage-block-aq16osz343o-827 .x_052b6b4c {
    text-align: left;
    line-height: 1.9375rem;
    font-size: 1.3622rem;
  }
  #element-__gpage-block-aq16osz343o-827 strong {
    font-weight: 700;
  }
  #element-__gpage-block-aq16osz343o-827.headline {
    font-weight: 700;
  }
  #page-block-crp778w2dru {
    height: 43.3125rem;
    max-width: 100%;
  }
  #page-block-crp778w2dru .section-holder-border {
    border: 0;
  }
  #page-block-crp778w2dru .section-block {
    background: url(//v.fastcdn.co/u/8f6a85c1/39260051-0-bg.png) repeat
      rgb(68, 43, 92) 50% 50% / auto;
    height: 43.3125rem;
  }
  #page-block-crp778w2dru .section-holder-overlay {
    display: none;
  }
  #element-516 {
    top: 5.375rem;
    left: 34.9375rem;
    height: 22.125rem;
    width: 25rem;
    z-index: 145;
  }
  .form {
    font-size: 0.8125rem;
  }
  .form-input {
    font-size: var(--desktop-input-font-size);
    height: 2.6875rem;
  }
  .form .phone-input-container .iti__selected-dial-code {
    font-size: var(--desktop-input-font-size);
  }
  .form-textarea {
    height: 6.25rem;
  }
  .form-label-title {
    margin: 0.3125rem 0 0.5rem;
    font-size: 0.89375rem;
    padding: 0;
    line-height: 1.1875rem;
  }
  .form-multiple-label {
    margin-bottom: 0.625rem;
    font-size: 0.9375rem;
    line-height: 1.1875rem;
    padding: 0;
  }
  .form-multiple-label:empty {
    display: inline;
  }
  .form-checkbox-label:after {
    top: 0.1rem;
  }
  .form-label-outside {
    margin-bottom: 0;
  }
  .form-multiple-label:before {
    transition:
      background-color 0.1s,
      border 0.1s;
    top: initial;
  }
  .form-radio-label:hover:before {
    border: 0.3125rem solid #9bc7fd;
  }
  .form-messagebox {
    transform: translate(0);
    display: flex;
  }
  .form-messagebox-left {
    transform: translateX(-100%);
    left: -0.625rem;
  }
  .form-messagebox-right {
    transform: translateX(100%);
    right: -0.625rem;
  }
  .form-messagebox:before {
    top: calc(50% - 0.1875rem);
    left: auto;
  }
  .form-messagebox-left:before {
    right: -0.1875rem;
  }
  .form-messagebox-right:before {
    left: -0.1875rem;
  }
  .notification-text {
    font-size: 3.125rem;
  }
  #element-28 {
    top: 0;
    left: 0;
    height: 22.125rem;
    width: 25rem;
    z-index: 19;
  }
  #element-28 .btn.btn-effect3d:active {
    box-shadow: none;
  }
  #element-28 .btn:hover {
    background: #16cea5;
    color: #ffffff;
  }
  #element-28 .btn {
    background: #0cdaac;
    color: #ffffff;
    font-size: 1.1146rem;
    font-family: Prompt;
    font-weight: 400;
    font-style: normal;
    height: 3.25rem;
    width: 24.75rem;
    border-radius: 3px;
  }
  #element-28 .form-label {
    color: #cfc0db;
  }
  #element-28 ::placeholder {
    color: #cfc0db;
  }
  #element-28 .form-input {
    color: #ffffff;
    background-color: #8761a4;
    border-color: #8761a4;
  }
  #element-28 .iti__country-container .iti__selected-country-primary {
    border-color: #8761a4;
  }
  #element-28 .form-select[aria-invalid="false"] {
    color: #ffffff;
  }
  #element-28 .user-invalid {
    border-color: #e12627;
  }
  #element-28 input::placeholder,
  #element-28 .form-label-inside {
    color: #cfc0db;
  }
  #element-28 select.valid {
    color: #ffffff;
  }
  #element-28 .form-btn-geometry {
    top: 23.25rem;
    left: 0.125rem;
    height: 3.25rem;
    width: 24.75rem;
    z-index: 145;
  }
  #element-32 {
    top: 7.75rem;
    left: 34.9375rem;
    height: 1.3125rem;
    width: 25rem;
    z-index: 146;
  }
  #element-32 .shape {
    border-bottom: 1px solid #cfc0db;
  }
  #element-33 {
    top: 11.375rem;
    left: 34.9375rem;
    height: 1.3125rem;
    width: 25rem;
    z-index: 147;
  }
  #element-33 .shape {
    border-bottom: 1px solid #cfc0db;
  }
  #element-30 {
    top: 12.5rem;
    left: 0;
    height: 7.125rem;
    width: 28.75rem;
    z-index: 14;
    color: #98a0a6;
    font-size: 2.5387rem;
    line-height: 3.5875rem;
    text-align: left;
  }
  #element-30 .x_8c048be8 {
    text-align: left;
    line-height: 3.5625rem;
    font-size: 2.5387rem;
  }
  #element-30 .x_f2074b6c {
    color: #ffffff;
  }
  #element-30 .x_41ae8345 {
    text-align: left;
    caret-color: rgb(255, 255, 255);
  }
  #element-31 {
    top: 20.625rem;
    left: 0;
    height: 4.25rem;
    width: 29.25rem;
    z-index: 15;
    color: #98a0a6;
    font-size: 1.4861rem;
    line-height: 2.1rem;
    text-align: left;
  }
  #element-31 .x_13aa4441 {
    text-align: left;
    line-height: 2.125rem;
    font-size: 1.4861rem;
  }
  #element-31 .x_f2074b6c {
    color: #ffffff;
  }
  #element-34 {
    top: 15.125rem;
    left: 34.9375rem;
    height: 1.3125rem;
    width: 25rem;
    z-index: 148;
  }
  #element-34 .shape {
    border-bottom: 1px solid #cfc0db;
  }
  #element-35 {
    top: 18.75rem;
    left: 34.9375rem;
    height: 1.3125rem;
    width: 25rem;
    z-index: 149;
  }
  #element-35 .shape {
    border-bottom: 1px solid #cfc0db;
  }
  #element-36 {
    top: 22.4375rem;
    left: 34.9375rem;
    height: 1.3125rem;
    width: 25rem;
    z-index: 150;
  }
  #element-36 .shape {
    border-bottom: 1px solid #cfc0db;
  }
  #element-815 {
    top: 27rem;
    left: 34.9375rem;
    height: 1.3125rem;
    width: 25rem;
    z-index: 151;
  }
  #element-815 .shape {
    border-bottom: 1px solid #cfc0db;
  }
  #element-523 {
    top: 32.9375rem;
    left: 37.4375rem;
    height: 2.75rem;
    width: 20rem;
    z-index: 76;
    color: #37465a;
    font-size: 0.8669rem;
    line-height: 1.4rem;
    text-align: center;
  }
  #element-523 .x_938e8cfc {
    text-align: center;
    line-height: 1.375rem;
    font-size: 0.8669rem;
  }
  #element-523 .x_3f8b9c9e {
    color: #cfc0db;
  }
  #element-813 {
    top: 36.25rem;
    left: 47.4375rem;
    height: 2.5625rem;
    width: 7.5rem;
    z-index: 143;
  }
  #element-813 .cropped {
    background: url(//v.fastcdn.co/u/8f6a85c1/58811452-0-Privacy-Policy.png) 0
      0 / 7.6875rem 2.5625rem;
  }
  #element-814 {
    top: 36.3125rem;
    left: 40rem;
    height: 2.5rem;
    width: 6.75rem;
    z-index: 144;
  }
  #page-block-7kbrls2f8wa {
    height: 10.9375rem;
    max-width: 100%;
  }
  #page-block-7kbrls2f8wa .section-holder-border {
    border: 0;
  }
  #page-block-7kbrls2f8wa .section-block {
    background: none;
    height: 10.9375rem;
  }
  #page-block-7kbrls2f8wa .section-holder-overlay {
    display: none;
  }
  #element-762 {
    top: 3.125rem;
    left: 0.3125rem;
    height: 4.75rem;
    width: 6.3125rem;
    z-index: 115;
  }
  #element-763 {
    top: 3.125rem;
    left: 7.875rem;
    height: 4.75rem;
    width: 6.3125rem;
    z-index: 117;
  }
  #element-764 {
    top: 3.125rem;
    left: 15.4375rem;
    height: 4.75rem;
    width: 6.3125rem;
    z-index: 118;
  }
  #element-765 {
    top: 3.125rem;
    left: 23.0625rem;
    height: 4.75rem;
    width: 6.3125rem;
    z-index: 119;
  }
  #element-766 {
    top: 3.125rem;
    left: 30.625rem;
    height: 4.75rem;
    width: 6.3125rem;
    z-index: 120;
  }
  #element-767 {
    top: 3.125rem;
    left: 38.1875rem;
    height: 4.75rem;
    width: 6.3125rem;
    z-index: 121;
  }
  #element-768 {
    top: 3.125rem;
    left: 45.75rem;
    height: 4.75rem;
    width: 6.3125rem;
    z-index: 141;
  }
  #element-769 {
    top: 3.125rem;
    left: 53.3125rem;
    height: 4.75rem;
    width: 6.3125rem;
    z-index: 142;
  }
  #page-block-6y050oio77h {
    height: 39.75rem;
    max-width: 100%;
  }
  #page-block-6y050oio77h .section-holder-border {
    border: 0;
  }
  #page-block-6y050oio77h .section-block {
    background: rgb(249, 249, 249);
    height: 39.75rem;
  }
  #page-block-6y050oio77h .section-holder-overlay {
    display: none;
  }
  #element-41 {
    top: 4.6875rem;
    left: 0;
    height: 13.25rem;
    width: 9.6875rem;
    z-index: 37;
  }
  #element-41 .shape {
    border: 0;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM89h8AApEBx2iaqpQAAAAASUVORK5CYII=)
      repeat rgb(240, 243, 245) 67% 47% / cover;
  }
  #element-42 {
    top: 4.6875rem;
    left: 10.25rem;
    height: 13.25rem;
    width: 9.6875rem;
    z-index: 38;
  }
  #element-42 .shape {
    border: 0;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM89h8AApEBx2iaqpQAAAAASUVORK5CYII=)
      repeat rgb(240, 243, 245) 50% 50% / cover;
  }
  #element-44 {
    top: 4.6875rem;
    left: 20.5rem;
    height: 13.25rem;
    width: 9.4375rem;
    z-index: 39;
  }
  #element-44 .shape {
    border: 0;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM89h8AApEBx2iaqpQAAAAASUVORK5CYII=)
      repeat rgb(240, 243, 245) 50% 50% / cover;
  }
  #element-43 {
    top: 4.6875rem;
    left: 30.5rem;
    height: 13.25rem;
    width: 9.25rem;
    z-index: 40;
  }
  #element-43 .shape {
    border: 0;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM89h8AApEBx2iaqpQAAAAASUVORK5CYII=)
      repeat rgb(240, 243, 245) 60% 53% / cover;
  }
  #element-45 {
    top: 4.6875rem;
    left: 40.3125rem;
    height: 13.25rem;
    width: 9.3125rem;
    z-index: 41;
  }
  #element-45 .shape {
    border: 0;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM89h8AApEBx2iaqpQAAAAASUVORK5CYII=)
      repeat rgb(240, 243, 245) 59% 54% / cover;
  }
  #element-526 {
    top: 4.6875rem;
    left: 50.5625rem;
    height: 13.25rem;
    width: 9.5rem;
    z-index: 42;
  }
  #element-526 .shape {
    border: 0;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM89h8AApEBx2iaqpQAAAAASUVORK5CYII=)
      repeat rgb(240, 243, 245) 98% 58% / cover;
  }
  #element-39 {
    top: 21.1875rem;
    left: 0;
    height: 2.4375rem;
    width: 59.9375rem;
    z-index: 36;
    color: #98a0a6;
    font-size: 1.7337rem;
    line-height: 2.45rem;
    text-align: center;
  }
  #element-39 .x_67c6b47b {
    text-align: center;
    line-height: 2.4375rem;
    font-size: 1.7337rem;
  }
  #element-39 .x_ebcb5a8d {
    color: #484848;
  }
  #element-40 {
    top: 25rem;
    left: 0;
    height: 8.4375rem;
    width: 59.9375rem;
    z-index: 34;
    color: #98a0a6;
    font-size: 1.0526rem;
    line-height: 1.7rem;
    text-align: center;
  }
  #element-40 .x_7a88b5a4 {
    text-align: center;
    line-height: 1.6875rem;
    font-size: 1.0526rem;
  }
  #element-40 .x_ebcb5a8d {
    color: #484848;
  }
  #element-40 .x_9e1789bd {
    text-align: left;
    caret-color: rgb(72, 72, 72);
  }
  #page-block-5yybmqvsesc {
    height: 32rem;
    max-width: 100%;
  }
  #page-block-5yybmqvsesc .section-holder-border {
    border: 0;
  }
  #page-block-5yybmqvsesc .section-block {
    background: none;
    height: 32rem;
  }
  #page-block-5yybmqvsesc .section-holder-overlay {
    display: none;
  }
  #element-567 {
    top: 6rem;
    left: -0.125rem;
    height: 2.125rem;
    width: 60rem;
    z-index: 77;
    color: #98a0a6;
    font-size: 1.4861rem;
    line-height: 2.1rem;
    text-align: center;
  }
  #element-567 .x_fc9d998b {
    text-align: center;
    line-height: 2.125rem;
    font-size: 1.4861rem;
  }
  #element-567 .x_ebcb5a8d {
    color: #484848;
  }
  #element-569 {
    top: 11.125rem;
    left: 0;
    height: 13rem;
    width: 18.625rem;
    z-index: 104;
  }
  #element-569 .shape {
    border: 0;
    background: none;
  }
  #element-568 {
    top: 11.125rem;
    left: 7.375rem;
    height: 4rem;
    width: 4rem;
    z-index: 103;
  }
  #element-577 {
    top: 16.1875rem;
    left: 0.125rem;
    height: 1.875rem;
    width: 18.75rem;
    z-index: 105;
    color: #98a0a6;
    font-size: 1.1765rem;
    line-height: 1.9rem;
    text-align: center;
  }
  #element-577 .x_4b32d65e {
    text-align: center;
    line-height: 1.875rem;
    font-size: 1.1765rem;
  }
  #element-577 .x_c3ede868 {
    color: #32174d;
  }
  #element-582 {
    top: 19.5625rem;
    left: 1.1875rem;
    height: 2.0625rem;
    width: 8.3125rem;
    z-index: 108;
  }
  #element-582 .shape {
    border: 0;
    border-radius: 6.25rem 6.25rem 6.25rem 6.25rem;
    background: rgb(228, 248, 245);
  }
  #element-583 {
    top: 19.9375rem;
    left: 1.4375rem;
    height: 1.375rem;
    width: 7.25rem;
    z-index: 109;
    color: #37465a;
    font-size: 0.8669rem;
    line-height: 1.4rem;
    text-align: center;
  }
  #element-583 .x_938e8cfc {
    text-align: center;
    line-height: 1.375rem;
    font-size: 0.8669rem;
  }
  #element-583 .x_b9f91c43 {
    color: #4ac5b6;
  }
  #element-584 {
    top: 19.5625rem;
    left: 9.8125rem;
    height: 2.0625rem;
    width: 7.6875rem;
    z-index: 111;
  }
  #element-584 .shape {
    border: 0;
    border-radius: 6.25rem 6.25rem 6.25rem 6.25rem;
    background: rgb(255, 223, 221);
  }
  #element-585 {
    top: 19.9375rem;
    left: 10.0625rem;
    height: 1.375rem;
    width: 7.25rem;
    z-index: 112;
    color: #37465a;
    font-size: 0.8669rem;
    line-height: 1.4rem;
    text-align: center;
  }
  #element-585 .x_938e8cfc {
    text-align: center;
    line-height: 1.375rem;
    font-size: 0.8669rem;
  }
  #element-585 .x_249cd66c {
    color: #de6661;
  }
  #element-580 {
    top: 22.1875rem;
    left: 1.4375rem;
    height: 2.125rem;
    width: 7.25rem;
    z-index: 106;
    color: #37465a;
    font-size: 1.7337rem;
    line-height: 2.1rem;
    text-align: center;
  }
  #element-580 .x_446dab97 {
    text-align: center;
    line-height: 2.125rem;
    font-size: 1.7337rem;
  }
  #element-580 .x_ebcb5a8d {
    color: #484848;
  }
  #element-581 {
    top: 22.1875rem;
    left: 10.0625rem;
    height: 2.125rem;
    width: 7.25rem;
    z-index: 107;
    color: #37465a;
    font-size: 1.7337rem;
    line-height: 2.1rem;
    text-align: center;
  }
  #element-581 .x_446dab97 {
    text-align: center;
    line-height: 2.125rem;
    font-size: 1.7337rem;
  }
  #element-581 .x_ebcb5a8d {
    color: #484848;
  }
  #element-570 {
    top: 11.125rem;
    left: 20.625rem;
    height: 13rem;
    width: 18rem;
    z-index: 90;
  }
  #element-570 .shape {
    border: 0;
    background: none;
  }
  #element-572 {
    top: 11.125rem;
    left: 28rem;
    height: 4rem;
    width: 4.0625rem;
    z-index: 91;
  }
  #element-576 {
    top: 16.1875rem;
    left: 20.75rem;
    height: 1.875rem;
    width: 18.6875rem;
    z-index: 92;
    color: #98a0a6;
    font-size: 1.1765rem;
    line-height: 1.9rem;
    text-align: center;
  }
  #element-576 .x_4b32d65e {
    text-align: center;
    line-height: 1.875rem;
    font-size: 1.1765rem;
  }
  #element-576 .x_c3ede868 {
    color: #32174d;
  }
  #element-578 {
    top: 19.0625rem;
    left: 26.125rem;
    height: 2.875rem;
    width: 7.75rem;
    z-index: 93;
    color: #37465a;
    font-size: 2.3529rem;
    line-height: 2.85rem;
    text-align: center;
  }
  #element-578 .x_b614627d {
    text-align: center;
    line-height: 2.875rem;
    font-size: 2.3529rem;
  }
  #element-579 {
    top: 21.9375rem;
    left: 20.875rem;
    height: 1.375rem;
    width: 18.25rem;
    z-index: 94;
    color: #37465a;
    font-size: 0.9907rem;
    line-height: 1.4rem;
    text-align: center;
  }
  #element-579 .x_2c80ab57 {
    text-align: center;
    line-height: 1.375rem;
    font-size: 0.9907rem;
  }
  #element-579 .x_ebcb5a8d {
    color: #484848;
  }
  #element-571 {
    top: 11.125rem;
    left: 41.1875rem;
    height: 13rem;
    width: 19.25rem;
    z-index: 85;
  }
  #element-571 .shape {
    border: 0;
    background: none;
  }
  #element-573 {
    top: 11.125rem;
    left: 48.5625rem;
    height: 4rem;
    width: 4rem;
    z-index: 86;
  }
  #element-575 {
    top: 16.1875rem;
    left: 41.1875rem;
    height: 1.875rem;
    width: 18.75rem;
    z-index: 88;
    color: #98a0a6;
    font-size: 1.1765rem;
    line-height: 1.9rem;
    text-align: center;
  }
  #element-575 .x_4b32d65e {
    text-align: center;
    line-height: 1.875rem;
    font-size: 1.1765rem;
  }
  #element-575 .x_c3ede868 {
    color: #32174d;
  }
  #element-574 {
    top: 19.625rem;
    left: 41.1875rem;
    height: 5.0625rem;
    width: 18.75rem;
    z-index: 87;
    color: #98a0a6;
    font-size: 1.0526rem;
    line-height: 1.7rem;
    text-align: center;
  }
  #element-574 .x_7a88b5a4 {
    text-align: center;
    line-height: 1.6875rem;
    font-size: 1.0526rem;
  }
  #element-574 .x_ebcb5a8d {
    color: #484848;
  }
  #element-574 .x_9e1789bd {
    text-align: left;
    caret-color: rgb(72, 72, 72);
  }
  #element-586 {
    top: 30.6875rem;
    left: 0;
    height: 1.3125rem;
    width: 59.9375rem;
    z-index: 114;
  }
  #element-586 .shape {
    border-bottom: 1px solid #f0f0f0;
  }
  #page-block-cwbu8jp41s {
    height: 41.25rem;
    max-width: 100%;
  }
  #page-block-cwbu8jp41s .section-holder-border {
    border: 0;
  }
  #page-block-cwbu8jp41s .section-block {
    background: rgb(255, 255, 255);
    height: 41.25rem;
  }
  #page-block-cwbu8jp41s .section-holder-overlay {
    display: none;
  }
  #element-707 {
    top: 6rem;
    left: 0;
    height: 2.125rem;
    width: 59.9375rem;
    z-index: 16;
    color: #98a0a6;
    font-size: 1.4861rem;
    line-height: 2.1rem;
    text-align: center;
  }
  #element-707 .x_fc9d998b {
    text-align: center;
    line-height: 2.125rem;
    font-size: 1.4861rem;
  }
  #element-707 .x_ebcb5a8d {
    color: #484848;
  }
  #element-707 .x_9e1789bd {
    text-align: left;
    caret-color: rgb(72, 72, 72);
  }
  #element-708 {
    top: 9.125rem;
    left: 0;
    height: 5.0625rem;
    width: 59.9375rem;
    z-index: 17;
    color: #98a0a6;
    font-size: 1.0526rem;
    line-height: 1.7rem;
    text-align: center;
  }
  #element-708 .x_7a88b5a4 {
    text-align: center;
    line-height: 1.6875rem;
    font-size: 1.0526rem;
  }
  #element-708 .x_ebcb5a8d {
    color: #484848;
  }
  #element-708 .x_9e1789bd {
    text-align: left;
    caret-color: rgb(72, 72, 72);
  }
  #element-710 {
    top: 17.3125rem;
    left: 3.9375rem;
    height: 6.0625rem;
    width: 6rem;
    z-index: 19;
  }
  #element-710 .cropped {
    background: url(//v.fastcdn.co/u/8f6a85c1/49951090-0-1B.svg) -0.1875rem 0 /
      6.1875rem 6.1875rem;
  }
  #element-712 {
    top: 17.3125rem;
    left: 19.1875rem;
    height: 6.0625rem;
    width: 6.25rem;
    z-index: 22;
  }
  #element-712 .cropped {
    background: url(//v.fastcdn.co/u/8f6a85c1/49951100-0-2B.svg) 0 -0.0625rem /
      6.25rem 6.25rem;
  }
  #element-714 {
    top: 17.3125rem;
    left: 34.6875rem;
    height: 6.0625rem;
    width: 6.25rem;
    z-index: 26;
  }
  #element-714 .cropped {
    background: url(//v.fastcdn.co/u/8f6a85c1/49951110-0-3B.svg) 0 -0.0625rem /
      6.25rem 6.25rem;
  }
  #element-716 {
    top: 17.3125rem;
    left: 50.0625rem;
    height: 6.0625rem;
    width: 6.25rem;
    z-index: 30;
  }
  #element-716 .cropped {
    background: url(//v.fastcdn.co/u/8f6a85c1/49951115-0-4B.svg) 0 -0.0625rem /
      6.25rem 6.25rem;
  }
  #element-709 {
    top: 24.9375rem;
    left: 0;
    height: 10.125rem;
    width: 13.8125rem;
    z-index: 18;
    color: #98a0a6;
    font-size: 1.0526rem;
    line-height: 1.7rem;
    text-align: center;
  }
  #element-709 .x_7a88b5a4 {
    text-align: center;
    line-height: 1.6875rem;
    font-size: 1.0526rem;
  }
  #element-709 .x_ebcb5a8d {
    color: #484848;
  }
  #element-709 .x_9e1789bd {
    text-align: left;
    caret-color: rgb(72, 72, 72);
  }
  #element-711 {
    top: 24.9375rem;
    left: 15.3125rem;
    height: 3.375rem;
    width: 14rem;
    z-index: 20;
    color: #98a0a6;
    font-size: 1.0526rem;
    line-height: 1.7rem;
    text-align: center;
  }
  #element-711 .x_7a88b5a4 {
    text-align: center;
    line-height: 1.6875rem;
    font-size: 1.0526rem;
  }
  #element-711 .x_ebcb5a8d {
    color: #484848;
  }
  #element-711 .x_9e1789bd {
    text-align: left;
    caret-color: rgb(72, 72, 72);
  }
  #element-713 {
    top: 24.9375rem;
    left: 30.9375rem;
    height: 3.375rem;
    width: 13.8125rem;
    z-index: 24;
    color: #98a0a6;
    font-size: 1.0526rem;
    line-height: 1.7rem;
    text-align: center;
  }
  #element-713 .x_7a88b5a4 {
    text-align: center;
    line-height: 1.6875rem;
    font-size: 1.0526rem;
  }
  #element-713 .x_ebcb5a8d {
    color: #484848;
  }
  #element-713 .x_9e1789bd {
    text-align: left;
    caret-color: rgb(72, 72, 72);
  }
  #element-715 {
    top: 24.9375rem;
    left: 46.4375rem;
    height: 8.4375rem;
    width: 13.5rem;
    z-index: 28;
    color: #98a0a6;
    font-size: 1.0526rem;
    line-height: 1.7rem;
    text-align: center;
  }
  #element-715 .x_7a88b5a4 {
    text-align: center;
    line-height: 1.6875rem;
    font-size: 1.0526rem;
  }
  #element-715 .x_ebcb5a8d {
    color: #484848;
  }
  #element-715 .x_9e1789bd {
    text-align: left;
    caret-color: rgb(72, 72, 72);
  }
  #page-block-u6qrj13o0v {
    height: 73.8125rem;
    max-width: 100%;
  }
  #page-block-u6qrj13o0v .section-holder-border {
    border: 0;
  }
  #page-block-u6qrj13o0v .section-block {
    background: none;
    height: 73.8125rem;
  }
  #page-block-u6qrj13o0v .section-holder-overlay {
    display: none;
  }
  #element-730 {
    top: 6.25rem;
    left: 0;
    height: 25.0625rem;
    width: 60rem;
    z-index: 123;
  }
  #element-729 {
    top: 34.4375rem;
    left: 0;
    height: 2.125rem;
    width: 59.9375rem;
    z-index: 124;
    color: #98a0a6;
    font-size: 1.4861rem;
    line-height: 2.1rem;
    text-align: center;
  }
  #element-729 .x_fc9d998b {
    text-align: center;
    line-height: 2.125rem;
    font-size: 1.4861rem;
  }
  #element-729 .x_ebcb5a8d {
    color: #484848;
  }
  #element-729 .x_9e1789bd {
    text-align: left;
    caret-color: rgb(72, 72, 72);
  }
  #element-723 {
    top: 39.6875rem;
    left: 0;
    height: 1.6875rem;
    width: 17.6875rem;
    z-index: 63;
    color: #98a0a6;
    font-size: 1.0526rem;
    line-height: 1.7rem;
    text-align: center;
  }
  #element-723 .x_7a88b5a4 {
    text-align: center;
    line-height: 1.6875rem;
    font-size: 1.0526rem;
  }
  #element-723 .x_c3ede868 {
    color: #32174d;
  }
  #element-724 {
    top: 39.6875rem;
    left: 21.1875rem;
    height: 1.6875rem;
    width: 17.75rem;
    z-index: 99;
    color: #98a0a6;
    font-size: 1.0526rem;
    line-height: 1.7rem;
    text-align: center;
  }
  #element-724 .x_7a88b5a4 {
    text-align: center;
    line-height: 1.6875rem;
    font-size: 1.0526rem;
  }
  #element-724 .x_9e1789bd {
    text-align: left;
    caret-color: rgb(72, 72, 72);
  }
  #element-724 .x_c3ede868 {
    color: #32174d;
  }
  #element-725 {
    top: 39.6875rem;
    left: 42.3125rem;
    height: 1.6875rem;
    width: 17.5625rem;
    z-index: 100;
    color: #98a0a6;
    font-size: 1.0526rem;
    line-height: 1.7rem;
    text-align: center;
  }
  #element-725 .x_7a88b5a4 {
    text-align: center;
    line-height: 1.6875rem;
    font-size: 1.0526rem;
  }
  #element-725 .x_c3ede868 {
    color: #32174d;
  }
  #element-725 .x_9e1789bd {
    text-align: left;
    caret-color: rgb(72, 72, 72);
  }
  #element-725 strong {
    font-weight: 700;
  }
  #element-717 {
    top: 44.875rem;
    left: 0;
    height: 5.0625rem;
    width: 17.6875rem;
    z-index: 33;
    color: #98a0a6;
    font-size: 1.0526rem;
    line-height: 1.7rem;
    text-align: center;
  }
  #element-717 .x_7a88b5a4 {
    text-align: center;
    line-height: 1.6875rem;
    font-size: 1.0526rem;
  }
  #element-717 .x_ebcb5a8d {
    color: #484848;
  }
  #element-717 .x_9e1789bd {
    text-align: left;
    caret-color: rgb(72, 72, 72);
  }
  #element-719 {
    top: 44.875rem;
    left: 21.125rem;
    height: 10.125rem;
    width: 17.6875rem;
    z-index: 55;
    color: #98a0a6;
    font-size: 1.0526rem;
    line-height: 1.7rem;
    text-align: center;
  }
  #element-719 .x_7a88b5a4 {
    text-align: center;
    line-height: 1.6875rem;
    font-size: 1.0526rem;
  }
  #element-719 .x_ebcb5a8d {
    color: #484848;
  }
  #element-719 .x_9e1789bd {
    text-align: left;
    caret-color: rgb(72, 72, 72);
  }
  #element-718 {
    top: 44.875rem;
    left: 42.3125rem;
    height: 3.375rem;
    width: 17.5625rem;
    z-index: 53;
    color: #98a0a6;
    font-size: 1.0526rem;
    line-height: 1.7rem;
    text-align: center;
  }
  #element-718 .x_7a88b5a4 {
    text-align: center;
    line-height: 1.6875rem;
    font-size: 1.0526rem;
  }
  #element-718 .x_ebcb5a8d {
    color: #484848;
  }
  #element-718 .x_9e1789bd {
    text-align: left;
    caret-color: rgb(72, 72, 72);
  }
  #element-726 {
    top: 57.0625rem;
    left: 0;
    height: 1.6875rem;
    width: 17.6875rem;
    z-index: 113;
    color: #98a0a6;
    font-size: 1.0526rem;
    line-height: 1.7rem;
    text-align: center;
  }
  #element-726 .x_7a88b5a4 {
    text-align: center;
    line-height: 1.6875rem;
    font-size: 1.0526rem;
  }
  #element-726 .x_9e1789bd {
    text-align: left;
    caret-color: rgb(72, 72, 72);
  }
  #element-726 .x_c3ede868 {
    color: #32174d;
  }
  #element-727 {
    top: 57.0625rem;
    left: 21.1875rem;
    height: 1.6875rem;
    width: 17.75rem;
    z-index: 116;
    color: #98a0a6;
    font-size: 1.0526rem;
    line-height: 1.7rem;
    text-align: center;
  }
  #element-727 .x_7a88b5a4 {
    text-align: center;
    line-height: 1.6875rem;
    font-size: 1.0526rem;
  }
  #element-727 .x_9e1789bd {
    text-align: left;
    caret-color: rgb(72, 72, 72);
  }
  #element-727 .x_c3ede868 {
    color: #32174d;
  }
  #element-728 {
    top: 57.0625rem;
    left: 42.3125rem;
    height: 1.6875rem;
    width: 17.5625rem;
    z-index: 122;
    color: #98a0a6;
    font-size: 1.0526rem;
    line-height: 1.7rem;
    text-align: center;
  }
  #element-728 .x_7a88b5a4 {
    text-align: center;
    line-height: 1.6875rem;
    font-size: 1.0526rem;
  }
  #element-728 .x_9e1789bd {
    text-align: left;
    caret-color: rgb(72, 72, 72);
  }
  #element-728 .x_c3ede868 {
    color: #32174d;
  }
  #element-721 {
    top: 60.1875rem;
    left: 0;
    height: 5.0625rem;
    width: 17.6875rem;
    z-index: 60;
    color: #98a0a6;
    font-size: 1.0526rem;
    line-height: 1.7rem;
    text-align: center;
  }
  #element-721 .x_7a88b5a4 {
    text-align: center;
    line-height: 1.6875rem;
    font-size: 1.0526rem;
  }
  #element-721 .x_ebcb5a8d {
    color: #484848;
  }
  #element-721 .x_9e1789bd {
    text-align: left;
    caret-color: rgb(72, 72, 72);
  }
  #element-720 {
    top: 60.1875rem;
    left: 21.125rem;
    height: 6.75rem;
    width: 17.6875rem;
    z-index: 101;
    color: #98a0a6;
    font-size: 1.0526rem;
    line-height: 1.7rem;
    text-align: center;
  }
  #element-720 .x_7a88b5a4 {
    text-align: center;
    line-height: 1.6875rem;
    font-size: 1.0526rem;
  }
  #element-720 .x_ebcb5a8d {
    color: #484848;
  }
  #element-720 .x_9e1789bd {
    text-align: left;
    caret-color: rgb(72, 72, 72);
  }
  #element-722 {
    top: 60.1875rem;
    left: 42.3125rem;
    height: 6.75rem;
    width: 17.5625rem;
    z-index: 102;
    color: #98a0a6;
    font-size: 1.0526rem;
    line-height: 1.7rem;
    text-align: center;
  }
  #element-722 .x_7a88b5a4 {
    text-align: center;
    line-height: 1.6875rem;
    font-size: 1.0526rem;
  }
  #element-722 .x_ebcb5a8d {
    color: #484848;
  }
  #element-722 .x_9e1789bd {
    text-align: left;
    caret-color: rgb(72, 72, 72);
  }
  #page-block-sfatg4kg7c {
    height: 33rem;
    max-width: 100%;
  }
  #page-block-sfatg4kg7c .section-holder-border {
    border: 0;
  }
  #page-block-sfatg4kg7c .section-block {
    background: rgb(249, 249, 249);
    height: 36rem;
  }
  #page-block-sfatg4kg7c .section-holder-overlay {
    display: none;
  }
  #element-734 {
    top: 7.25rem;
    left: 17.625rem;
    height: 2.125rem;
    width: 27.75rem;
    z-index: 13;
    color: #98a0a6;
    font-size: 1.4861rem;
    line-height: 2.1rem;
    text-align: center;
  }
  #element-734 .x_fc9d998b {
    text-align: center;
    line-height: 2.125rem;
    font-size: 1.4861rem;
  }
  #element-734 .x_ebcb5a8d {
    color: #484848;
  }
  #element-734 .x_9e1789bd {
    text-align: left;
    caret-color: rgb(72, 72, 72);
  }
  #element-735 {
    top: 12.375rem;
    left: 0;
    height: 3rem;
    width: 3rem;
    z-index: 78;
  }
  #element-736 {
    top: 15.875rem;
    left: 0;
    height: 1.875rem;
    width: 8.5rem;
    z-index: 79;
    color: #98a0a6;
    font-size: 1.1765rem;
    line-height: 1.9rem;
    text-align: left;
  }
  #element-736 .x_f72c77f2 {
    text-align: left;
    line-height: 1.875rem;
    font-size: 1.1765rem;
  }
  #element-736 .x_ebcb5a8d {
    color: #484848;
  }
  #element-737 {
    top: 18.25rem;
    left: 0;
    height: 8.4375rem;
    width: 13.5rem;
    z-index: 80;
    color: #98a0a6;
    font-size: 1.0526rem;
    line-height: 1.7rem;
    text-align: left;
  }
  #element-737 .x_80f7663c {
    text-align: left;
    line-height: 1.6875rem;
    font-size: 1.0526rem;
  }
  #element-737 .x_ebcb5a8d {
    color: #484848;
  }
  #element-737 .x_9e1789bd {
    text-align: left;
    caret-color: rgb(72, 72, 72);
  }
  #element-738 {
    top: 12.375rem;
    left: 18.125rem;
    height: 3rem;
    width: 3.0625rem;
    z-index: 45;
  }
  #element-739 {
    top: 15.875rem;
    left: 18.125rem;
    height: 1.875rem;
    width: 8.6875rem;
    z-index: 46;
    color: #98a0a6;
    font-size: 1.1765rem;
    line-height: 1.9rem;
    text-align: left;
  }
  #element-739 .x_f72c77f2 {
    text-align: left;
    line-height: 1.875rem;
    font-size: 1.1765rem;
  }
  #element-739 .x_ebcb5a8d {
    color: #484848;
  }
  #element-740 {
    top: 18.25rem;
    left: 18.125rem;
    height: 8.4375rem;
    width: 19.75rem;
    z-index: 47;
    color: #98a0a6;
    font-size: 1.0526rem;
    line-height: 1.7rem;
    text-align: left;
  }
  #element-740 .x_80f7663c {
    text-align: left;
    line-height: 1.6875rem;
    font-size: 1.0526rem;
  }
  #element-740 .x_ebcb5a8d {
    color: #484848;
  }
  #element-740 .x_9e1789bd {
    text-align: left;
    caret-color: rgb(72, 72, 72);
  }
  #element-741 {
    top: 12.375rem;
    left: 42.1875rem;
    height: 3rem;
    width: 3.25rem;
    z-index: 57;
  }
  #element-742 {
    top: 15.875rem;
    left: 42.1875rem;
    height: 1.875rem;
    width: 8.75rem;
    z-index: 58;
    color: #98a0a6;
    font-size: 1.1765rem;
    line-height: 1.9rem;
    text-align: left;
  }
  #element-742 .x_f72c77f2 {
    text-align: left;
    line-height: 1.875rem;
    font-size: 1.1765rem;
  }
  #element-742 .x_ebcb5a8d {
    color: #484848;
  }
  #element-743 {
    top: 18.25rem;
    left: 42.1875rem;
    height: 6.75rem;
    width: 17.75rem;
    z-index: 59;
    color: #98a0a6;
    font-size: 1.0526rem;
    line-height: 1.7rem;
    text-align: left;
  }
  #element-743 .x_80f7663c {
    text-align: left;
    line-height: 1.6875rem;
    font-size: 1.0526rem;
  }
  #element-743 .x_ebcb5a8d {
    color: #484848;
  }
  #element-743 .x_9e1789bd {
    text-align: left;
    caret-color: rgb(72, 72, 72);
  }
  #element-745 {
    top: 13.1875rem;
    left: -25.625rem;
    height: 1.375rem;
    width: 25rem;
    z-index: 73;
    display: none;
  }
  #element-745 .shape {
    border-bottom: 2px dashed #8b63a7;
  }
  #element-746 {
    top: 13.1875rem;
    left: 3.4375rem;
    height: 1.375rem;
    width: 13.8125rem;
    z-index: 81;
  }
  #element-746 .shape {
    border-bottom: 2px solid #8b63a7;
  }
  #element-747 {
    top: 13.1875rem;
    left: 21.75rem;
    height: 1.375rem;
    width: 19.75rem;
    z-index: 82;
  }
  #element-747 .shape {
    border-bottom: 2px solid #8b63a7;
  }
  #element-744 {
    top: 13.1875rem;
    left: 45.9375rem;
    height: 1.375rem;
    width: 20rem;
    z-index: 69;
  }
  #element-744 .shape {
    border-bottom: 2px dashed #8b63a7;
  }
  #page-block-7peatp556bf {
    height: 54.25rem;
    max-width: 100%;
  }
  #page-block-7peatp556bf .section-holder-border {
    border: 0;
  }
  #page-block-7peatp556bf .section-block {
    background: none;
    height: 54.25rem;
  }
  #page-block-7peatp556bf .section-holder-overlay {
    display: none;
  }
  #element-790 {
    top: 6rem;
    left: 0;
    height: 2.125rem;
    width: 59.75rem;
    z-index: 43;
    color: #98a0a6;
    font-size: 1.4861rem;
    line-height: 2.1rem;
    text-align: center;
  }
  #element-790 .x_fc9d998b {
    text-align: center;
    line-height: 2.125rem;
    font-size: 1.4861rem;
  }
  #element-790 .x_ebcb5a8d {
    color: #484848;
  }
  #element-790 .x_9e1789bd {
    text-align: left;
    caret-color: rgb(72, 72, 72);
  }
  #element-791 {
    top: 8.5rem;
    left: 0;
    height: 1.6875rem;
    width: 59.75rem;
    z-index: 44;
    color: #98a0a6;
    font-size: 1.0526rem;
    line-height: 1.7rem;
    text-align: center;
  }
  #element-791 .x_7a88b5a4 {
    text-align: center;
    line-height: 1.6875rem;
    font-size: 1.0526rem;
  }
  #element-791 .x_ebcb5a8d {
    color: #484848;
  }
  #element-791 .x_9e1789bd {
    text-align: left;
    caret-color: rgb(72, 72, 72);
  }
  #element-798 {
    top: 12.9375rem;
    left: 0;
    height: 13.5rem;
    width: 19rem;
    z-index: 61;
  }
  #element-798 .shape {
    border: 0;
    border-radius: 0 0 0 0;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM89h8AApEBx2iaqpQAAAAASUVORK5CYII=)
      repeat rgb(240, 243, 245) 53% 37% / cover;
  }
  #element-792 {
    top: 12.9375rem;
    left: 20.4375rem;
    height: 13.5rem;
    width: 19.0625rem;
    z-index: 68;
  }
  #element-792 .shape {
    border: 0;
    border-radius: 0 0 0 0;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM89h8AApEBx2iaqpQAAAAASUVORK5CYII=)
      repeat rgb(240, 243, 245) 50% 50% / cover;
  }
  #element-799 {
    top: 12.9375rem;
    left: 41.125rem;
    height: 13.5rem;
    width: 18.75rem;
    z-index: 89;
  }
  #element-799 .shape {
    border: 0;
    border-radius: 0 0 0 0;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM89h8AApEBx2iaqpQAAAAASUVORK5CYII=)
      repeat rgb(240, 243, 245) 50% 50% / cover;
  }
  #element-793 {
    top: 23.625rem;
    left: 0.875rem;
    height: 3.375rem;
    width: 16.9375rem;
    z-index: 64;
    color: #98a0a6;
    font-size: 1.0526rem;
    line-height: 1.7rem;
    text-align: left;
  }
  #element-793 .x_80f7663c {
    text-align: left;
    line-height: 1.6875rem;
    font-size: 1.0526rem;
  }
  #element-793 .x_f2074b6c {
    color: #ffffff;
  }
  #element-793 .x_9e1789bd {
    text-align: left;
    caret-color: rgb(72, 72, 72);
  }
  #element-794 {
    top: 23.625rem;
    left: 21.5rem;
    height: 1.6875rem;
    width: 16.9375rem;
    z-index: 71;
    color: #98a0a6;
    font-size: 1.0526rem;
    line-height: 1.7rem;
    text-align: left;
  }
  #element-794 .x_80f7663c {
    text-align: left;
    line-height: 1.6875rem;
    font-size: 1.0526rem;
  }
  #element-794 .x_f2074b6c {
    color: #ffffff;
  }
  #element-794 .x_9e1789bd {
    text-align: left;
    caret-color: rgb(72, 72, 72);
  }
  #element-800 {
    top: 23.625rem;
    left: 42.1875rem;
    height: 1.6875rem;
    width: 16.8125rem;
    z-index: 95;
    color: #98a0a6;
    font-size: 1.0526rem;
    line-height: 1.7rem;
    text-align: left;
  }
  #element-800 .x_80f7663c {
    text-align: left;
    line-height: 1.6875rem;
    font-size: 1.0526rem;
  }
  #element-800 .x_f2074b6c {
    color: #ffffff;
  }
  #element-800 .x_9e1789bd {
    text-align: left;
    caret-color: rgb(72, 72, 72);
  }
  #element-805 {
    top: 27.875rem;
    left: 20.5rem;
    height: 1.5rem;
    width: 19rem;
    z-index: 133;
  }
  #element-805 .shape {
    border-bottom: 4px solid #f0f3f5;
  }
  #element-802 {
    top: 27.9375rem;
    left: 0;
    height: 1.5rem;
    width: 19rem;
    z-index: 128;
  }
  #element-802 .shape {
    border-bottom: 4px solid #f0f3f5;
  }
  #element-808 {
    top: 27.9375rem;
    left: 41.1875rem;
    height: 1.5rem;
    width: 18.8125rem;
    z-index: 138;
  }
  #element-808 .shape {
    border-bottom: 4px solid #f0f3f5;
  }
  #element-795 {
    top: 29.6875rem;
    left: 1.9375rem;
    height: 5.25rem;
    width: 15rem;
    z-index: 125;
    color: #98a0a6;
    font-size: 1.6099rem;
    line-height: 2.6rem;
    text-align: center;
  }
  #element-795 .x_1925a137 {
    text-align: center;
    line-height: 1.625rem;
    font-size: 1.6099rem;
  }
  #element-795 .x_ebcb5a8d {
    color: #484848;
  }
  #element-795 .x_9e1789bd {
    text-align: left;
    caret-color: rgb(72, 72, 72);
  }
  #element-804 {
    top: 29.6875rem;
    left: 22.4375rem;
    height: 5.25rem;
    width: 15rem;
    z-index: 132;
    color: #98a0a6;
    font-size: 1.6099rem;
    line-height: 2.6rem;
    text-align: center;
  }
  #element-804 .x_1925a137 {
    text-align: center;
    line-height: 1.625rem;
    font-size: 1.6099rem;
  }
  #element-804 .x_ebcb5a8d {
    color: #484848;
  }
  #element-804 .x_9e1789bd {
    text-align: left;
    caret-color: rgb(72, 72, 72);
  }
  #element-807 {
    top: 29.875rem;
    left: 43.125rem;
    height: 4.875rem;
    width: 14.9375rem;
    z-index: 137;
    color: #98a0a6;
    font-size: 1.3622rem;
    line-height: 1.65rem;
    text-align: center;
  }
  #element-807 .x_b796efc8 {
    text-align: center;
    line-height: 1.625rem;
    font-size: 1.3622rem;
  }
  #element-807 .x_ebcb5a8d {
    color: #484848;
  }
  #element-807 .x_9e1789bd {
    text-align: left;
    caret-color: rgb(72, 72, 72);
  }
  #element-806 {
    top: 37.4375rem;
    left: 20.4375rem;
    height: 1.5rem;
    width: 19rem;
    z-index: 134;
  }
  #element-806 .shape {
    border-bottom: 4px solid #f0f3f5;
  }
  #element-803 {
    top: 37.5rem;
    left: -0.0625rem;
    height: 1.5rem;
    width: 19.0625rem;
    z-index: 130;
  }
  #element-803 .shape {
    border-bottom: 4px solid #f0f3f5;
  }
  #element-809 {
    top: 37.5rem;
    left: 41.125rem;
    height: 1.5rem;
    width: 19rem;
    z-index: 139;
  }
  #element-809 .shape {
    border-bottom: 4px solid #f0f3f5;
  }
  #element-801 {
    top: 38.9375rem;
    left: -0.0625rem;
    height: 3.375rem;
    width: 19.0625rem;
    z-index: 126;
    color: #98a0a6;
    font-size: 1.0526rem;
    line-height: 1.7rem;
    text-align: center;
  }
  #element-801 .x_7a88b5a4 {
    text-align: center;
    line-height: 1.6875rem;
    font-size: 1.0526rem;
  }
  #element-801 .x_ebcb5a8d {
    color: #484848;
  }
  #element-801 .x_9e1789bd {
    text-align: left;
    caret-color: rgb(72, 72, 72);
  }
  #element-796 {
    top: 38.9375rem;
    left: 20.4375rem;
    height: 6.75rem;
    width: 19.0625rem;
    z-index: 131;
    color: #98a0a6;
    font-size: 1.0526rem;
    line-height: 1.7rem;
    text-align: center;
  }
  #element-796 .x_7a88b5a4 {
    text-align: center;
    line-height: 1.6875rem;
    font-size: 1.0526rem;
  }
  #element-796 .x_ebcb5a8d {
    color: #484848;
  }
  #element-796 .x_9e1789bd {
    text-align: left;
    caret-color: rgb(72, 72, 72);
  }
  #element-797 {
    top: 38.9375rem;
    left: 40.9375rem;
    height: 10.125rem;
    width: 19rem;
    z-index: 135;
    color: #98a0a6;
    font-size: 1.0526rem;
    line-height: 1.7rem;
    text-align: center;
  }
  #element-797 .x_7a88b5a4 {
    text-align: center;
    line-height: 1.6875rem;
    font-size: 1.0526rem;
  }
  #element-797 .x_ebcb5a8d {
    color: #484848;
  }
  #element-797 .x_9e1789bd {
    text-align: left;
    caret-color: rgb(72, 72, 72);
  }
  #page-block-74qk0seeq8 {
    height: 32.25rem;
    max-width: 100%;
  }
  #page-block-74qk0seeq8 .section-holder-border {
    border: 0;
  }
  #page-block-74qk0seeq8 .section-block {
    background: rgb(255, 255, 255);
    height: 32.25rem;
  }
  #page-block-74qk0seeq8 .section-holder-overlay {
    display: none;
  }
  #element-243 {
    top: 0;
    left: -4.4375rem;
    height: 27.8125rem;
    width: 68rem;
    z-index: 21;
  }
  #element-243 .shape {
    border: 0.0625rem solid #a3bac6;
    background: rgb(249, 249, 249);
  }
  #element-243 .contents {
    font-family: Open Sans !important;
    font-weight: 400 !important;
    background-color: rgb(249, 249, 249) !important;
    border-radius: 0px !important;
    border-color: rgb(163, 186, 198) !important;
    border-width: 0 !important;
    width: 1100 !important;
    height: 27.8125rem !important;
    border-style: solid !important;
    background-repeat: repeat !important;
    background-position: center !important;
    background-size: cover !important;
  }
  #element-236 {
    top: 6.625rem;
    left: 2.125rem;
    height: 14.25rem;
    width: 26.25rem;
    z-index: 23;
  }
  #element-236 iframe {
    width: 420px;
    height: 228px;
  }
  #element-237 {
    top: 6.625rem;
    left: 31.1875rem;
    height: 14.25rem;
    width: 26.5rem;
    z-index: 25;
  }
  #element-237 iframe {
    width: 424px;
    height: 228px;
  }
  #page_block_header {
    height: 30rem;
    max-width: 100%;
  }
  #page_block_header .section-holder-border {
    border: 0;
  }
  #page_block_header .section-block {
    background: none;
    height: 30rem;
  }
  #page_block_header .section-holder-overlay {
    display: none;
  }
  #element-385 {
    top: 4.6875rem;
    left: 0;
    height: 16.125rem;
    width: 15.8125rem;
    z-index: 54;
  }
  #element-385 .shape {
    border: 0.0625rem solid #a3bac6;
    border-radius: 0.4375rem 0.4375rem 0.4375rem 0.4375rem;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM89h8AApEBx2iaqpQAAAAASUVORK5CYII=)
      repeat rgb(240, 243, 245) 50% 50% / cover;
  }
  #element-386 {
    top: 4.6875rem;
    left: 22.125rem;
    height: 16.125rem;
    width: 15.1875rem;
    z-index: 62;
  }
  #element-386 .shape {
    border: 0.0625rem solid #a3bac6;
    border-radius: 0.4375rem 0.4375rem 0.4375rem 0.4375rem;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM89h8AApEBx2iaqpQAAAAASUVORK5CYII=)
      repeat rgb(240, 243, 245) 50% 50% / cover;
  }
  #element-387 {
    top: 4.6875rem;
    left: 43.625rem;
    height: 16.125rem;
    width: 15.5rem;
    z-index: 65;
  }
  #element-387 .shape {
    border: 0.0625rem solid #a3bac6;
    border-radius: 0.4375rem 0.4375rem 0.4375rem 0.4375rem;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM89h8AApEBx2iaqpQAAAAASUVORK5CYII=)
      repeat rgb(240, 243, 245) 50% 50% / cover;
  }
  #element-471 {
    top: 21.9375rem;
    left: 0.1875rem;
    height: 3rem;
    width: 15.75rem;
    z-index: 66;
    color: #37465a;
    font-size: 0.9288rem;
    line-height: 1.5rem;
    text-align: center;
  }
  #element-471 .x_519e17eb {
    text-align: center;
    line-height: 1.5rem;
    font-size: 0.9288rem;
  }
  #element-471 .x_ebcb5a8d {
    color: #484848;
  }
  #element-472 {
    top: 21.9375rem;
    left: 22.375rem;
    height: 4.5rem;
    width: 15.5rem;
    z-index: 67;
    color: #37465a;
    font-size: 0.9288rem;
    line-height: 1.5rem;
    text-align: center;
  }
  #element-472 .x_519e17eb {
    text-align: center;
    line-height: 1.5rem;
    font-size: 0.9288rem;
  }
  #element-472 .x_ebcb5a8d {
    color: #484848;
  }
  #element-473 {
    top: 21.9375rem;
    left: 44.0625rem;
    height: 3rem;
    width: 15.4375rem;
    z-index: 72;
    color: #37465a;
    font-size: 0.9288rem;
    line-height: 1.5rem;
    text-align: center;
  }
  #element-473 .x_519e17eb {
    text-align: center;
    line-height: 1.5rem;
    font-size: 0.9288rem;
  }
  #element-473 .x_ebcb5a8d {
    color: #484848;
  }
  #page-block-nig0x1pdc3a {
    height: 35.25rem;
    max-width: 100%;
  }
  #page-block-nig0x1pdc3a .section-holder-border {
    border: 0;
  }
  #page-block-nig0x1pdc3a .section-block {
    background: url(//v.fastcdn.co/u/8f6a85c1/49485940-0-Footer-BG.png) repeat
      50% 0 / cover;
    height: 35.25rem;
  }
  #page-block-nig0x1pdc3a .section-holder-overlay {
    display: none;
  }
  #element-670 {
    top: 3.8125rem;
    left: 0;
    height: 1.625rem;
    width: 2.9375rem;
    z-index: 74;
  }
  #element-670 .shape {
    border-bottom: 6px solid #ffffff;
  }
  #element-666 {
    top: 5.4375rem;
    left: 32.8125rem;
    height: 14.5rem;
    width: 22.5625rem;
    z-index: 48;
  }
  #element-666 .cropped {
    background: url(//v.fastcdn.co/u/8f6a85c1/49486060-0-ss.svg) 0 -0.0625rem /
      22.6875rem 14.5625rem;
  }
  #element-667 {
    top: 5.75rem;
    left: 0;
    height: 6.375rem;
    width: 23.5625rem;
    z-index: 49;
    color: #37465a;
    font-size: 1.9814rem;
    line-height: 3.2rem;
    text-align: left;
  }
  #element-667 .x_c8f60032 {
    text-align: left;
    line-height: 3.1875rem;
    font-size: 1.9814rem;
  }
  #element-667 .x_f2074b6c {
    color: #ffffff;
  }
  #element-668 {
    top: 12.375rem;
    left: 0;
    height: 3.25rem;
    width: 23.5625rem;
    z-index: 50;
    color: #37465a;
    font-size: 0.9907rem;
    line-height: 1.6rem;
    text-align: left;
  }
  #element-668 .x_3579aa00 {
    text-align: left;
    line-height: 1.625rem;
    font-size: 0.9907rem;
  }
  #element-668 .x_f2074b6c {
    color: #ffffff;
  }
  #element-669 {
    top: 17.125rem;
    left: -0.0625rem;
    height: 2.5rem;
    width: 14.25rem;
    z-index: 51;
  }
  #element-669 .btn.btn-effect3d:active {
    box-shadow: none;
  }
  #element-669 .btn:hover {
    background: #12e4b5;
    color: #ffffff;
  }
  #element-669 .btn {
    background: #0cdaac;
    color: #ffffff;
    font-size: 0.8669rem;
    font-family: Prompt;
    font-weight: 400;
    font-style: normal;
    height: 2.5rem;
    width: 14.25rem;
    border-radius: 3px;
  }
  #element-659 {
    top: 25.625rem;
    left: 0;
    height: 1.3125rem;
    width: 60rem;
    z-index: 52;
  }
  #element-659 .shape {
    border-bottom: 1px solid #ffffff;
  }
  #element-664 {
    top: 28.8125rem;
    left: 9.5625rem;
    height: 3.625rem;
    width: 26.125rem;
    z-index: 96;
  }
  #element-664 .shape {
    border: 0;
    border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
    background: rgb(70, 46, 95);
  }
  #element-662 {
    top: 28.875rem;
    left: 10.25rem;
    height: 3.6875rem;
    width: 18.6875rem;
    z-index: 97;
  }
  #element-662 .btn.btn-effect3d:active {
    box-shadow: none;
  }
  #element-662 .btn:hover {
    background: transparent;
    color: #ffffff;
  }
  #element-662 .btn {
    color: #ffffff;
    font-size: 0.9907rem;
    font-family: "Open Sans";
    font-weight: 700;
    font-style: normal;
    height: 2.9375rem;
    width: 7.1875rem;
    border-radius: 3px;
  }
  #element-662 .form-label {
    color: #dad5df;
  }
  #element-662 ::placeholder {
    color: #dad5df;
  }
  #element-662 .form-input {
    color: #ffffff;
  }
  #element-662 .form-select[aria-invalid="false"] {
    color: #ffffff;
  }
  #element-662 .user-invalid {
    border-color: #e12627;
  }
  #element-662 input::placeholder,
  #element-662 .form-label-inside {
    color: #dad5df;
  }
  #element-662 select.valid {
    color: #ffffff;
  }
  #element-662 .form-btn-geometry {
    top: 0.375rem;
    left: 18.75rem;
    height: 2.9375rem;
    width: 7.1875rem;
    z-index: 97;
  }
  #element-665 {
    top: 29.0625rem;
    left: -0.0625rem;
    height: 3.25rem;
    width: 8.5625rem;
    z-index: 70;
    color: #37465a;
    font-size: 0.9907rem;
    line-height: 1.6rem;
    text-align: left;
  }
  #element-665 .x_3579aa00 {
    text-align: left;
    line-height: 1.625rem;
    font-size: 0.9907rem;
  }
  #element-665 .x_f2074b6c {
    color: #ffffff;
  }
  #element-671 {
    top: 29.4375rem;
    left: 28.1875rem;
    height: 2.5rem;
    width: 1.3125rem;
    z-index: 98;
  }
  #element-671 .shape {
    border-right: 1px solid #dad5df;
  }
  #element-660 {
    top: 29.9375rem;
    left: 50%;
    height: 1.625rem;
    width: 11.75rem;
    z-index: 56;
    color: #37465a;
    font-size: 0.9907rem;
    line-height: 1.6rem;
    text-align: center;
    transform: translateX(-50%);
  }
  #element-660 .x_dc68832a {
    text-align: center;
    line-height: 1.625rem;
    font-size: 0.9907rem;
  }
  #element-660 .x_f2074b6c {
    color: #ffffff;
  }
}

select.form-select {
  background-image:
    linear-gradient(45deg, transparent 50%, white 50%),
    linear-gradient(135deg, white 50%, transparent 50%);
  background-position:
    calc(100% - 20px) calc(1em + 2px),
    calc(100% - 15px) calc(1em + 2px),
    calc(100% - 2.5em) 0.5em;
  background-size:
    5px 5px,
    5px 5px,
    1px 1.5em;
  background-repeat: no-repeat;
}

select.form-select option {
  background-color: #fee;
  color: #442b5c;
}

.combodate {
  display: block;
}

.combodate select {
  width: 32% !important;
}

form.form button:disabled {
  pointer-events: none;
  cursor: not-allowed;
  opacity: 0.8;
}

form .prop-btn {
  cursor: pointer;
  user-select: none;
}

.label-white {
  color: white;
  padding: 0 0 25px 0;
  display: block;
  clear: both;
}

.url-link {
  color: #fff;
}

.tu_list {
	padding-bottom: 100px;
    box-sizing: border-box;
  padding-top: 100px;
  .tu_item {
    margin: 26px 20px 16px;
    border-radius: 16px;
    padding: 30px 40px 30px 26px;
    display: flex;
    justify-content: space-between;
    position: relative;
    overflow: hidden;
    .renzh {
      position: absolute;
      right: -80px;
      top: 42px;
      font-size: 24px;
      padding: 1px 59px;
      font-style: normal;
      transform: rotate(45deg);
      background: linear-gradient(
        90deg,
        #3882b0,
        #a8197a,
        #541349,
        #541950,
        #541851
      );
      color: #fff;
    }
    .sm_in_c {
      width: 186px;
      height: 186px;
      border-radius: 50%;
    }
    .info_box {
      .c_id {
        width: 200px;
        text-align: center;
        background: linear-gradient(
          90deg,
          #3882b0,
          #a8197a,
          #541349,
          #541950,
          #541851
        );
        color: #fff;
        border-radius: 40px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 24px;
        padding: 5px 10px;
      }
      .c_c {
        color: #313131;
        font-size: 26px;
        padding-top: 10px;
      }
      .c_b_k {
        display: flex;
        align-items: center;
        color: #666;
        font-size: 22px;
        padding-top: 16px;
        .sm_in {
          width: 30px;
          height: 30px;
          &.cc {
            margin-left: 16px;
          }
        }
      }
    }
  }
}
.nav_box {
  display: flex;
  align-items: center;
  justify-content: space-around;
  border: 1px solid #766350;
  margin: 10px 20px;
  border-radius: 16px;
  padding: 30px 20px;
  background: linear-gradient(120deg, #212121, #313131);
  .x_p {
    text-align: center;
    color: #e6b98a;
    img {
      height: 76px;
    }
  }
}
.put_tit {
  font-weight: bold;
  color: #e6b98a;
  font-size: 28px;
  padding-left: 16px;
  position: relative;
  &::before {
    content: "";
    display: block;
    position: absolute;
    width: 8px;
    height: 30px;
    background-color: #e6b98a;
    left: 0;
    top: 6px;
  }
}
.wuzii {
  margin: 26px 20px 16px;
  border-radius: 16px;
  padding: 30px 20px;
  background: linear-gradient(120deg, #212121, #313131);
  border: 1px solid #766350;
  .xx_bc {
    display: flex;
    flex-wrap: wrap;
    font-size: 26px;
    color: #ccc;
    justify-content: space-between;
    padding-top: 10px;
    .top_link {
      padding: 20px 10px;
    }
  }
}
.wuzii_p {
  margin: 26px 20px 16px;
  background: linear-gradient(120deg, #212121, #313131);
  display: flex;
  padding: 20px 20px;
  justify-content: space-between;
  .xx_bc_u {
    color: #ccc;
  }
}
.header {
  // height: 13vw;
  // position: fixed;
  // top: 0;
  // left: 0;
  // width: 100%;
  // z-index: 2;
  // background-color: #1f1c1f;
  height: 13vw;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  background-color: #1f1c1f;
}
.header_content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  margin: 0 40px;
  color: #fff;

  .img {
    height: 80px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.notice-swiper {
  height: 11vw;
  font-size: 4vw;
  border-radius: 16px;
  border: 1px solid #766350;
}
.sub {
  background: rgb(63, 58, 91);
  padding: 8px;
  color: rgb(235, 202, 175);
  font-size: 24px;
  border-radius: 16px 0;
  margin-left: 4px;
}
.gdgride {
  padding-right: 40px;
}
.gdgride div {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
}
.gdgride span {
  position: absolute;
  z-index: 9;
  background-color: #ebcaaf;
  color: #8d684b;
  transform: rotate(45deg);
  width: 20vw;
  height: 20vw;
  font-size: 3vw;
  top: -11vw;
  right: -11vw;
}
.gdgride span i {
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 700;
}
.van-image {
  position: relative;
  display: inline-block;
}
.horizontalItem {
  display: flex;
  border-bottom: 2px solid #eee;
  padding: 40px 0 4vw;
}
.horizontalItem .imgBox {
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  margin-right: 40px;
}
.horizontalItem .imgBox span {
  position: absolute;
  z-index: 9;
  background-color: #ebcaaf;
  color: #8d684b;
  transform: rotate(45deg);
  width: 20vw;
  height: 20vw;
  top: -11vw;
  right: -11vw;
}
.horizontalItem .imgBox i {
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 700;
  font-size: 4vw;
}
.top {
  display: flex;
}
.horizontalItem .top div:first-child,
.horizontalItem .top div :nth-child(2) {
  background: linear-gradient(180deg, #e7caaf, #fff7ed);
  color: #a4826b;
  font-weight: 600;
  font-size: 3vw;
  padding: 3px;
  margin-right: 10px;
}
.horizontalItem .top div:first-child,
.horizontalItem .top div:nth-child(2) {
  background: linear-gradient(180deg, #e7caaf, #fff7ed);
  color: #a4826b;
  font-weight: 600;
  font-size: 3vw;
  padding: 3px;
  margin-right: 10px;
}
.horizontalItem .tags {
  display: flex;
  margin: 10px 0 10px;
  flex-wrap: wrap;
}
.horizontalItem .tags .van-tag {
  padding: 15px;
  font-size: 3vw;
  margin: 0 10px 10px 0;
  border-radius: 16px;
}
.horizontalItem .yueta {
  background: linear-gradient(90deg, #df35ad, #4f1db5);
  color: #fff;
  border-radius: 16px;
  padding: 20px 0;
  text-align: center;
  font-size: 3vw;
}
.OnlineMatching {
  height: 28vw;
  overflow: hidden;
}

.OnlineMatching ul li {
  text-align: center;
  color: #fff;
  font-size: 4vw;
  margin-top: 20px;
}

@media screen and (min-width: 1024px) {
  .bg-container {
    width: 430px; /* H5原设计宽度 */
    height: 100%;
    margin: 0 auto; /* 居中显示 */
    position: relative;
    top: 0;
    left: 0;
    right: 0;
  }

  .header {
    height: 50px;
    width: 100%;
    position: static;
  }

  .tu_list {
    padding-top: 10px;
  }

  .tu_list .tu_item {
    margin: 16px;
    padding: 10px;
    border-radius: 10px;
    width: 90%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .tu_list .tu_item .sm_in_c {
    width: 100px;
    height: 100px;
  }

  .tu_list .tu_item .renzh {
    font-size: 14px;
    padding: 2px 40px;
    right: -27px;
    top: 28px;
  }

  .tu_list .tu_item .info_box .c_id {
    width: 40%;
    font-size: 14px;
    padding: 3px;
  }

  .tu_list .tu_item .info_box .c_c {
    font-size: 14px;
    padding-top: 10px;
  }

  .tu_list .tu_item .info_box .c_b_k {
    font-size: 12px;
  }

  .tu_list .tu_item .info_box .c_b_k .sm_in {
    width: 16px;
    height: 16px;
  }
}
</style>
